import React, { Component } from "react";
import { Link, Redirect, withRouter, NavLink } from "react-router-dom";

import pako from "pako";
import * as actionFunction from "../../../actions/common";
import $, { cssNumber } from "jquery";
import moment, { unix } from "moment";
import CryptoJS from "crypto-js";
import config from "react-global-configuration";
import "../../chat/chat.css";

import Skeleton from "react-loading-skeleton";
import Header from "../../../Header";
import EditorNew from "../../Editor/EditorNew";
import CustomSelect from "../../multiselectcustom/CustomSelect";
import CustomModal from "../modals/CustomModal";
import WarningModal from "../../WarningModal";
import { maskEmail, maskPhone } from "./Utility";
import MaskTableRow from "./MaskTableRow";
import { toast, Bounce } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Cookies from "js-cookie";

class NewLayoutFive extends Component {
	constructor() {
		super();
		var has_local_data = localStorage.getItem("encdata") ? 1 : 0;
		var localdata = has_local_data ? this.decrypt(localStorage.getItem("encdata"), 0) : "";
		this.state = {
			data: {},
			applications: [],
			login_details: [],
			upload_details: [],
			packageData: [],
			package_name: "",
			apiKey: "",
			apiKeyStatus: "",
			count: "",
			key: 1,
			packageData: "",
			bandwidth_log: "0",
			get_bandwidth_api: "0",
			bandwidth: "",
			storage: "",
			currency: [],
			andr_fcm_key: "",
			showDelayedComponent: false,
			andr_deep_link_code: "",
			andr_client_id: "",
			andr_client_secret: "",
			showWarning: false,
			deleteEmail: "",
			andr_force_update_version: "",
			andr_refresh_token: "",
			ios_fcm_key: "",
			ios_deep_link_code: "",
			ios_secret_code: "",
			ios_force_update_version: "",
			ios_mode: "",
			roku_sandbox_key: "",
			roku_production_key: "",
			roku_force_update_version: "",
			roku_android_mode: "",
			edit_access: "",
			android_view_state: 1,
			ios_view_state: 1,
			roku_view_state: 1,
			apple_view_state: 1,
			fire_view_state: 1,
			android_id: "",
			android_config_id: "",
			ios_config_id: "",
			roku_config_id: "",
			apple_config_id: "",
			android_version_code_id: "",
			ios_version_code_id: "",
			roku_version_code_id: "",
			subadmin_count: "",
			account_manager: "",
			cards_list: [],
			payment_method: "",
			revenue_last_month: "",
			total_no_of_subscribed_users: "0",
			enduser_count: "",
			loader: 1,
			apiUrl: this.decryptconfigdata("apiUrl"),
			studioUrl: this.decryptconfigdata("studioUrl"),
			userAuthKey: has_local_data ? localdata.user_key : "",
			userId: has_local_data ? localdata.user_id : "",
			local_data: has_local_data ? this.decrypt(localStorage.getItem("encdata"), 0) : "",
			logo: "",
			server_id: 1,
			muvi_ownership: [],
			crmNotes: [],
			noteContent: "",
			isContactEdit: false,
			isShowOwnerShip: false,
			isShowContactShip: false,

			noteAdding: 0,
			noteError: false,
			editId: 1,
			userList: {},
			userType: "internal",
			note: "",
			userUUID: 0,
			contactIndex: "",
			contactsEdit: { name: "", email: "", phone_number: "", designation: "" },
			chatInformation: {},
			other_contacts: [],
			chatDetail: {},
			customer_tattle_uuid: 0,
			asyncApiData: {},
			updateOwnerShip: {},
			customSelectValue: {},
			crmdata: {},
			isShowSideModal: false,
			shouldRerender: false,
			storePermission: localStorage.getItem("store_permission"),
		};
		this.getCustomerDetails = this.getCustomerDetails.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onChangeaction = this.onChangeaction.bind(this);
		this.handleKeyUp = this.keyUpHandler.bind(this);
		this.showmodalref = React.createRef(null);
	}
	getQueryString() {
		const searchParams = new URLSearchParams(this.props.location.search);
		const queryString = searchParams.get("debug");
		const debug = queryString == null || queryString == "false" ? false : true;
		return debug;
	}
	getAPIQueryString() {
		const searchParams = new URLSearchParams(this.props.location.search);
		const queryString = searchParams.get("api");
		const isApiCall = queryString == null || queryString == "false" ? false : true;
		return isApiCall;
	}
	decryptconfigdata(configkey) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return plaintext;
	}

	decrypt(findresponse, flg) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var res = flg ? findresponse.encdata : findresponse;
		var bytes = CryptoJS.AES.decrypt(res, key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return JSON.parse(plaintext);
	}

	encryptdata(msg) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var bytes = CryptoJS.AES.encrypt(JSON.stringify(msg), key, {
			iv,
		}).toString();

		return bytes;
	}

	rawjsonparse(findresponse, flg) {
		return findresponse;
	}
	goToCustomerStore(email, password, studio_id) {
		if (window.confirm("Are you sure to login this store")) {
			var win = window.open(
				this.state.studioUrl +
				"/login/storeLogin/email/" +
				email +
				"/password/" +
				password +
				"/studio_id/" +
				studio_id,
				"_blank"
			);
			win.focus();
		}
	}

	onChangePackage(propertyName, event) {
		this.setState({ ...this.state, package_name: event.target.value }, function () {
			console.log(this.state.package_name, 457345234234);
		});
	}
	toggle1() {
		$("#sdk_change").hide();
		$("#sdk_change_save").show();
		$("#sdk_name").hide();
		$("#sdk_span_txt").show();
	}
	toggle2() {
		var sdk_name = $("#sdk_name_txt").val();
		if (sdk_name == "") {
			alert("Sdk name can not be empty");
			return false;
		} else {
			if (window.confirm("Are you sure to update the sdk name ?")) {
				var studios_id = $("#studios_id").val();
				$.post(
					this.state.apiUrl + "/adminRest/updatesdk",
					{
						sdk_name: sdk_name,
						studio_id: studios_id,
						userAuthKey: this.state.userAuthKey,
					},
					function (res) {
						$("#sdk_change").show();
						$("#sdk_change_save").hide();
						$("#sdk_name").show();
						$("#sdk_span_txt").hide();
					}
				);
				this.getCustomerDetails();
			}
		}
	}

	disabletoken() {
		if (window.confirm("Are you sure, you want to disable the API Key for this studio?")) {
			var studios_id = $("#studios_id").val();
			$.post(
				this.state.apiUrl + "/adminRest/disableApiKey",
				{ studio_id: studios_id, userAuthKey: this.state.userAuthKey },
				function (res) { }
			);
		}
		this.getCustomerDetails();
	}

	ownerShipModal = () => {
		return (
			<div
				className="modal fade"
				id="manageMuviOwnership"
				tabindex="-1"
				role="dialog"
				aria-labelledby="manageMuviOwnershipLabel"
				ref={this.showmodalref}
			>
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className="modal-header">
							<button
								type="button"
								className="close"
								data-dismiss="modal"
								aria-label="Close"
							// onClick={handleClose}
							>
								<span aria-hidden="true">&times;</span>
							</button>
							<h5 className="modal-title" id="manageMuviOwnershipLabel">
								Manage Muvi Ownership
							</h5>
						</div>
						<form onSubmit={this.ownerShipSubmitHandler}>
							<div className="modal-body">
								<div className="alert alert-info" role="alert">
									Note: Assigning an account manager will mark this customer as Key Account, to Unmark
									it please open customer details page and Unmark it.
								</div>

								<div class="form-group">
									<label for="recipient-name" className="control-label">
										Account Manager
									</label>
									{console.log(this.state.customSelectValue, 67543234232)}
									<CustomSelect
										value={
											(this.state.customSelectValue &&
												this.state.customSelectValue.hasOwnProperty("account_manager") &&
												this.state.customSelectValue.account_manager) ||
											(this.state.data &&
												this.state.data.account_manager &&
												this.state.asyncApiData.hasOwnProperty("account_manager") &&
												this.state.asyncApiData.account_manager.length > 0 &&
												this.state.asyncApiData.account_manager.filter(
													(item) => item.value === this.state.data.account_manager
												))
										}
										options={Object.keys(this.state.userList).map((item) => {
											return {
												label: this.state.userList[item].name,
												value: this.state.userList[item].user_uuid,
												image: this.state.userList[item].profile_pic,
											};
										})}
										onChange={(evt) => this.ownerShipHandler("account_manager", evt)}
										async={true}
										loadOptions={(evt) =>
											this.asyncApiCall(
												evt,
												`${this.decryptconfigdata(
													"apiUrl"
												)}/tattle/GetGroupMembers?email=accountmanagement@muvi.com`,
												"account_manager"
											)
										}
									/>
								</div>
								<div class="form-group">
									<label for="recipient-name" className="control-label">
										TSE Owner
									</label>
									<CustomSelect
										value={
											(this.state.customSelectValue &&
												this.state.customSelectValue.hasOwnProperty("tse_owner") &&
												this.state.customSelectValue.tse_owner) ||
											(this.state.data &&
												this.state.data.tse_owner &&
												this.state.asyncApiData.hasOwnProperty("tse_owner") &&
												this.state.asyncApiData.tse_owner.length > 0 &&
												this.state.asyncApiData.tse_owner.filter(
													(item) => item.value === this.state.data.tse_owner
												))
										}
										async={true}
										loadOptions={(evt) =>
											this.asyncApiCall(
												evt,
												`${this.decryptconfigdata(
													"apiUrl"
												)}/tattle/GetGroupMembers?email=support@muvi.com`,
												"tse_owner"
											)
										}
										options={Object.keys(this.state.userList).map((item) => {
											return {
												label: this.state.userList[item].name,
												value: this.state.userList[item].user_uuid,
												image: this.state.userList[item].profile_pic,
											};
										})}
										onChange={(evt) => this.ownerShipHandler("tse_owner", evt)}
									/>
								</div>
								<div class="form-group">
									<label for="recipient-name" className="control-label">
										Sales Manager
									</label>
									<CustomSelect
										value={
											(this.state.customSelectValue &&
												this.state.customSelectValue.hasOwnProperty("sales_manager") &&
												this.state.customSelectValue.sales_manager) ||
											(this.state.data &&
												this.state.data.sales_manager &&
												this.state.asyncApiData.hasOwnProperty("sales_manager") &&
												this.state.asyncApiData.sales_manager.length > 0 &&
												this.state.asyncApiData.sales_manager.filter(
													(item) => item.value === this.state.data.sales_manager
												))
										}
										async={true}
										loadOptions={(evt) =>
											this.asyncApiCall(
												evt,
												`${this.decryptconfigdata(
													"apiUrl"
												)}/tattle/GetGroupMembers?email=sales@muvi.com`,
												"sales_manager"
											)
										}
										onChange={(evt) => this.ownerShipHandler("sales_manager", evt)}
									/>
								</div>
							</div>
							<div className="modal-footer">
								<span
									type="button"
									className="btn btn-blue"
									data-dismiss="modal"
								// onClick={handleClose}
								>
									Close
								</span>
								<button
									type="submit"
									className="btn btn-primary"
								// data-dismiss="modal"
								// onClick={handleSubmit}
								>
									Submit
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		);
	};

	processDeleteHandler = async () => {
		const response = await fetch(`${process.env.REACT_APP_CRM}/muvi6/remove-other-contacts`, {
			method: "POST",
			body: JSON.stringify({
				customer_id: this.props.match.params.appToken,
				email: this.state.deleteEmail,
			}),
		});
		const rdata = await response.json();
		console.log(rdata, 678456353453);
		if (rdata.code === 200) {
			const contactsother = [...this.state.other_contacts];
			let newcontact = contactsother.filter((item) => item.email !== this.state.deleteEmail);
			this.setState((state) => {
				return {
					...state,
					other_contacts: newcontact,
					showWarning: false,
				};
			});
		}
	};

	generatetoken() {
		if (window.confirm("Are you sure, you want to create the API Key for this studio?")) {
			var studios_id = $("#studios_id").val();
			$.post(
				this.state.apiUrl + "/adminRest/GenerateApiKey",
				{ studio_id: studios_id, userAuthKey: this.state.userAuthKey },
				function (res) { }
			);
		}
		this.getCustomerDetails();
	}

	keyUpHandler() {
		$(".force_update_version").keyup(function () {
			var val = $(this).val();
			if (isNaN(val)) {
				val = val.replace(/[^0-9\.]/g, "");
				if (val.split(".").length > 5) val = val.replace(/\.+$/, "");
			}
			$(this).val(val);
		});
	}
	updateBillingDetails() {
		var appToken = this.props.match.params.studioId; //"TeeoXC2ql1M1KFQTAoW33e4LwSGjRgOz";
		const type = this.state.data.customer_type.toLowerCase();

		fetch(`${process.env.REACT_APP_CRM}/cron/get-crm-billings?type=${type}&update=3&app_token=${appToken}`)
			.then((response) => response.json())
			.then((result) => {
				if (result && result.code === 200) {
					this.setState({
						shouldRerender: true,
					});
				}
			})
			.catch((error) => {
				console.error("There was a problem with the fetch operation:", error);
			});
	}
	getCustomerDetails(enterpriseurl) {
		//process.env.REACT_APP_CRM +
		const debug = this.getQueryString();
		let bodyParams = {
			studio_id: this.props.match.params.studioId,
			is_live: false,
			// enterprise_api_gateway_url: enterpriseurl,
			server_id: this.state.server_id,
			debug,
		};
		const compressedPostData = debug ? JSON.stringify(bodyParams) : pako.gzip(JSON.stringify(bodyParams));
		fetch(process.env.REACT_APP_CRM + "/muvi5/view-details", {
			method: "POST",
			dataType: "json",
			body: compressedPostData,
		})
			.then((response) => (debug ? response.json() : response.arrayBuffer())) // Get response body as ArrayBuffer
			.then((buffer) => {
				const findresponse = debug ? buffer : actionFunction.decompressjsondata(buffer);

				let { account_manager, ...rest } = findresponse.data[0];
				this.setState(
					{
						...this.state,
						data: {
							...this.state.data,
							...findresponse.crm_user,
							...rest,
						},
						applications: findresponse.applications || [],
						other_contacts: findresponse.users || [],
						loader: 0,
					},
					() => {
						this.getCrmNotes(this.state.data.customer_tattle_uuid);
						this.otherBillingDetails();
						// this.showLoginDetails();
						// this.showUploadDetails();
						this.timer = setTimeout(() => {
							this.setState({ showDelayedComponent: true });
						});
					}
				);
			}) /*
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				this.setState(
					{
						data: findresponse && findresponse.data[0],
						applications: findresponse && findresponse.applications,
						loader: 0,
					},
					() => {}
				);
			})*/
			.then(() => {
				const isApiTrue = this.getAPIQueryString();
				if (isApiTrue) {
					this.updateBillingDetails();
				}
			})
			.then(() => {
				// this.customerDeepLinking();
			})
			.catch((error) => {
				console.error("There was a problem with the fetch operation:", error);
			});
	}
	otherBillingDetails(enterpriseurl) {
		const debug = this.getQueryString();
		let bodyParams = {
			studio_id: this.props.match.params.studioId,
			is_live: false,
			// enterprise_api_gateway_url: enterpriseurl,
			server_id: this.state.server_id,
			debug,
		};
		const compressedPostData = debug ? JSON.stringify(bodyParams) : pako.gzip(JSON.stringify(bodyParams));
		fetch(process.env.REACT_APP_CRM + "/muvi5/other-billing-details", {
			method: "POST",
			dataType: "json",
			body: compressedPostData,
		})
			.then((response) => (debug ? response.json() : response.arrayBuffer())) // Get response body as ArrayBuffer
			.then((buffer) => {
				const findresponse = debug ? buffer : actionFunction.decompressjsondata(buffer);
				this.setState({
					package_name: findresponse && findresponse.package_name,
					// bandwidth_log: findresponse && findresponse.bandwidth_log,
					storage: findresponse && findresponse.storage,
					currency: findresponse && findresponse.currency,
					apiKey: findresponse && findresponse.apiKey,
					apiKeyStatus: findresponse && findresponse.apiKeyStatus,
					subadmin_count: findresponse && findresponse.subadmin_count,
					cards_list: findresponse && findresponse.cards_list,
					payment_method: findresponse && findresponse.payment_method,
					revenue_last_month: findresponse && findresponse.revenue_last_month,
					total_no_of_subscribed_users: findresponse && findresponse.total_no_of_subscribed_users,
					enduser_count: findresponse && findresponse.enduser_count,
				});
			}) /*
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				this.setState({
					package_name: findresponse && findresponse.package_name,
					// bandwidth_log: findresponse && findresponse.bandwidth_log,
					storage: findresponse && findresponse.storage,
					currency: findresponse && findresponse.currency,
					apiKey: findresponse && findresponse.apiKey,
					apiKeyStatus: findresponse && findresponse.apiKeyStatus,
					subadmin_count: findresponse && findresponse.subadmin_count,
					cards_list: findresponse && findresponse.cards_list,
					payment_method: findresponse && findresponse.payment_method,
					revenue_last_month: findresponse && findresponse.revenue_last_month,
					total_no_of_subscribed_users: findresponse && findresponse.total_no_of_subscribed_users,
					enduser_count: findresponse && findresponse.enduser_count,
				});
			})*/
			.then(() => {
				this.getBandwidthDetails();
			})
			.catch((error) => {
				console.error("There was a problem with the fetch operation:", error);
			});
	}

	showLoginDetails(url) {
		this.setState((state) => {
			return {
				...state,
				isLoadingApiCalling: true,
			};
		});
		const debug = this.getQueryString();
		let bodyParams = {
			studio_id: this.props.match.params.studioId,
			is_live: false,
			// enterprise_api_gateway_url: url,
			server_id: this.state.server_id,
			debug,
		};
		const compressedPostData = debug ? JSON.stringify(bodyParams) : pako.gzip(JSON.stringify(bodyParams));
		fetch(process.env.REACT_APP_CRM + "/muvi5/show-login-details", {
			method: "POST",
			dataType: "json",
			body: compressedPostData,
		})
			.then((response) => (debug ? response.json() : response.arrayBuffer())) // Get response body as ArrayBuffer
			.then((buffer) => {
				const findresponse = debug ? buffer : actionFunction.decompressjsondata(buffer);
				this.setState({
					login_details: (findresponse && findresponse.login_details) || [],
					isLoadingApiCalling: false,
				});
			}) /*
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				this.setState({
					login_details: findresponse && findresponse.login_details,
				});
			})*/
			.catch((error) => {
				console.error("There was a problem with the fetch operation:", error);
			});
	}
	customerDeepLinking() {
		this.setState((state) => {
			return {
				...state,
				isLoadingApiCalling: true,
			};
		});
		const debug = this.getQueryString();
		let bodyParams = {
			studio_id: this.props.match.params.studioId,
			user_id: this.state.userId,
			is_live: false,
			debug,
		};
		const compressedPostData = debug ? JSON.stringify(bodyParams) : pako.gzip(JSON.stringify(bodyParams));
		fetch(process.env.REACT_APP_CRM + "/muvi5/customer-deep-linking", {
			method: "POST",
			dataType: "json",
			body: compressedPostData,
		})
			.then((response) => (debug ? response.json() : response.arrayBuffer())) // Get response body as ArrayBuffer
			.then((buffer) => {
				const findresponse = debug ? buffer : actionFunction.decompressjsondata(buffer);
				const androidData = (findresponse && findresponse.android_data) || {};
				const iosData = (findresponse && findresponse.ios_data) || {};
				const rokuData = (findresponse && findresponse.roku_data) || {};
				this.setState({
					android_id: androidData.android_id || "", // Provide a default value if undefined
					andr_fcm_key: androidData.fcm_key || "", // Provide a default value if undefined
					andr_deep_link_code: androidData.deep_link_code || "", // Provide a default value if undefined
					android_config_id: androidData.android_config_id,
					andr_client_id: androidData.client_id,
					andr_client_secret: androidData.client_secret,
					andr_refresh_token: androidData.refresh_token,
					android_version_code_id: androidData.android_version_code_id,

					ios_fcm_key: iosData.fcm_key,
					ios_deep_link_code: iosData.deep_link_code,
					ios_config_id: iosData.ios_config_id,
					ios_secret_code: iosData.secreat_code,
					ios_mode: iosData.ios_mode,
					ios_version_code_id: iosData.ios_version_code_id,
					ios_force_update_version: iosData.version_code,
					roku_config_id: rokuData.roku_config_id,
					roku_sandbox_key: rokuData.sandbox_code,
					roku_production_key: rokuData.production_code,
					roku_mode: rokuData.roku_mode,
					roku_version_code_id: rokuData.roku_version_code_id,
					roku_force_update_version: rokuData.version_code,
					user_permission: findresponse && findresponse.user_permission,
					isLoadingApiCalling: false,
				});
			}) /*
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				const androidData = (findresponse && findresponse.android_data) || {};
				const iosData = (findresponse && findresponse.ios_data) || {};
				const rokuData = (findresponse && findresponse.roku_data) || {};
				this.setState({
					android_id: androidData.android_id || "", // Provide a default value if undefined
					andr_fcm_key: androidData.fcm_key || "", // Provide a default value if undefined
					andr_deep_link_code: androidData.deep_link_code || "", // Provide a default value if undefined
					android_config_id: androidData.android_config_id,
					andr_client_id: androidData.client_id,
					andr_client_secret: androidData.client_secret,
					andr_refresh_token: androidData.refresh_token,
					android_version_code_id: androidData.android_version_code_id,

					ios_fcm_key: iosData.fcm_key,
					ios_deep_link_code: iosData.deep_link_code,
					ios_config_id: iosData.ios_config_id,
					ios_secret_code: iosData.secreat_code,
					ios_mode: iosData.ios_mode,
					ios_version_code_id: iosData.ios_version_code_id,
					ios_force_update_version: iosData.version_code,
					roku_config_id: rokuData.roku_config_id,
					roku_sandbox_key: rokuData.sandbox_code,
					roku_production_key: rokuData.production_code,
					roku_mode: rokuData.roku_mode,
					roku_version_code_id: rokuData.roku_version_code_id,
					roku_force_update_version: rokuData.version_code,
					user_permission: findresponse && findresponse.user_permission,
				});
				
			})*/
			.catch((error) => {
				console.error("There was a problem with the fetch operation:", error);
			});
	}

	showUploadDetails(url) {
		this.setState((state) => {
			return {
				...state,
				isLoadingApiCalling: true,
			};
		});
		const debug = this.getQueryString();
		let bodyParams = {
			studio_id: this.props.match.params.studioId,
			is_live: false,
			// enterprise_api_gateway_url: url,
			server_id: this.state.server_id,
			debug,
		};
		const compressedPostData = debug ? JSON.stringify(bodyParams) : pako.gzip(JSON.stringify(bodyParams));
		fetch(process.env.REACT_APP_CRM + "/muvi5/show-upload-details", {
			method: "POST",
			dataType: "json",
			body: compressedPostData,
		})
			.then((response) => (debug ? response.json() : response.arrayBuffer())) // Get response body as ArrayBuffer
			.then((buffer) => {
				const findresponse = debug ? buffer : actionFunction.decompressjsondata(buffer);
				this.setState({
					upload_details: findresponse && findresponse.upload_details,
					count: findresponse && findresponse.count,
					isLoadingApiCalling: false,
				});
			}) /*
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				this.setState({
					upload_details: findresponse && findresponse.upload_details,
					count: findresponse && findresponse.count,
				});
			})*/
			.catch((error) => {
				console.error("There was a problem with the fetch operation:", error);
			});
	}

	getuploaddetails() {
		return this.state.isLoadingApiCalling ? (
			<div className="loader-new"></div>
		) : this.state.count > 0 ? (
			<div class="list_check">
				<div class="tickets hidden-sm">
					<div className="body-content">
						<div className="table-wrap">
							<table style={{ tableLayout: "fixed", minWidth: "100%" }}>
								<thead>
									<tr>
										<th style={(styleObj.intra_col_10, styleObj.table_heading)}>File Name</th>
										<th style={(styleObj.intra_col_15, styleObj.table_heading)}>
											Upload Start Time
										</th>
										<th style={(styleObj.intra_col_15, styleObj.table_heading)}>Upload End Time</th>
										<th style={(styleObj.intra_col_15, styleObj.table_heading)}>
											Upload Cancel Time
										</th>
										<th style={(styleObj.intra_col_15, styleObj.table_heading)}>
											Encode Start Time
										</th>
										<th style={(styleObj.intra_col_15, styleObj.table_heading)}>Encode End Time</th>
										<th style={(styleObj.intra_col_15, styleObj.table_heading)}>
											Encode Fail Time
										</th>
									</tr>
								</thead>
								<tbody>
									{this.state.upload_details.map((value) => (
										<tr key={value.film_name}>
											<td style={styleObj.table_td}>{value.film_name}</td>
											<td style={styleObj.table_td}>{value.upload_start_time}</td>
											<td style={styleObj.table_td}>{value.upload_end_time}</td>
											<td style={styleObj.table_td}>{value.upload_cancel_time}</td>
											<td style={styleObj.table_td}>{value.encoding_start_time}</td>
											<td style={styleObj.table_td}>{value.encoding_end_time}</td>
											<td style={styleObj.table_td}>{value.encode_fail_time}</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					</div>
					{/* <ul class="tickets_head" style={{ fontSize: "11px", fontWeight: "600" }}>
						<li style={styleObj.intra_col_10}>File Name</li>
						<li style={styleObj.intra_col_15}>Upload Start Time</li>
						<li style={styleObj.intra_col_15}>Upload End Time</li>
						<li style={styleObj.intra_col_15}>Upload Cancel Time</li>
						<li style={styleObj.intra_col_15}>Encode Start Time</li>
						<li style={styleObj.intra_col_15}>Encode End Time</li>
						<li style={styleObj.intra_col_15}>Encode Fail Time</li>
					</ul>
					{this.state.upload_details.map((upload_details, key) => (
						<ul class="tickets_number">
							<li style={(styleObj.intra_col_10, styleObj.upload_ul_li)}>{upload_details.film_name}</li>
							<li style={(styleObj.intra_col_15, styleObj.upload_ul_li)}>{upload_details.upload_start_time}</li>
							<li style={(styleObj.intra_col_15, styleObj.upload_ul_li)}>{upload_details.upload_end_time}</li>
							<li style={(styleObj.intra_col_15, styleObj.upload_ul_li)}>{upload_details.upload_cancel_time}</li>
							<li style={(styleObj.intra_col_15, styleObj.upload_ul_li)}>{upload_details.encoding_start_time}</li>
							<li style={(styleObj.intra_col_15, styleObj.upload_ul_li)}>{upload_details.encoding_end_time}</li>
							<li style={(styleObj.intra_col_15, styleObj.upload_ul_li)}>{upload_details.encode_fail_time}</li>
						</ul>
					))} */}
				</div>

				<div class="customer_mob hidden-md">
					{this.state.upload_details.map((upload_details, key) => (
						<div class="custmer_list_mob">
							<h4 class="list_title">{upload_details.film_name}</h4>
							<div class="wrap">{upload_details.upload_start_time}</div>
						</div>
					))}
				</div>
			</div>
		) : (
			<div class="row">
				<div className="not-data-found">
					<svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
						<g clip-path="url(#clip0_504_30600)">
							<path
								d="M48.5215 39.9595C48.959 40.7456 49.8374 41.1301 50.738 41.125C52.2693 41.1182 53.4963 42.4221 53.3647 43.979C53.2485 45.3582 52.0044 46.375 50.6201 46.375H42V47.25H6.12498C4.62791 47.25 3.42479 45.9973 3.5034 44.4849C3.5786 43.0647 4.85179 42 6.27366 42H6.99998C8.06297 42 8.90379 41.0532 8.72606 39.9561C8.58592 39.0964 7.77757 38.5 6.90599 38.5H2.62498C1.12791 38.5 -0.0752122 37.2473 0.00340108 35.7349C0.0785966 34.3147 1.35179 33.25 2.77366 33.25H8.31248C9.52073 33.25 10.5 32.2708 10.5 31.0625C10.5 29.8542 9.52073 28.875 8.31248 28.875C7.10423 28.875 6.12498 27.8958 6.12498 26.6875C6.12498 25.4792 7.10423 24.5 8.31248 24.5H15.75V18.375H9.18748C7.44261 18.375 6.03612 16.9138 6.13011 15.1484C6.21556 13.4924 7.70237 12.25 9.36009 12.25H15.75V8.75H49.4375C51.1824 8.75 52.5888 10.2112 52.4949 11.9766C52.4094 13.6326 50.9226 14.875 49.2649 14.875H46.8125C45.0676 14.875 43.6611 16.3362 43.7551 18.1016C43.8406 19.7576 45.3274 21 46.9851 21H49C50.5552 21 51.7942 22.3535 51.6062 23.9446C51.449 25.2656 50.2527 26.1953 48.9248 26.2517C47.8772 26.2944 47.0688 27.26 47.2842 28.3555C47.4499 29.186 48.2326 29.75 49.0786 29.75H52.9375C54.6824 29.75 56.0888 31.2112 55.9949 32.9766C55.9094 34.6326 54.4226 35.875 52.7649 35.875H50.75C48.8325 35.875 47.3952 37.9309 48.5215 39.9595ZM2.18748 28.875C3.39573 28.875 4.37498 27.8958 4.37498 26.6875C4.37498 25.4792 3.39573 24.5 2.18748 24.5C0.979231 24.5 -1.6893e-05 25.4792 -1.6893e-05 26.6875C-1.6893e-05 27.8958 0.979231 28.875 2.18748 28.875ZM2.18748 28.875C3.39573 28.875 4.37498 27.8958 4.37498 26.6875C4.37498 25.4792 3.39573 24.5 2.18748 24.5C0.979231 24.5 -1.6893e-05 25.4792 -1.6893e-05 26.6875C-1.6893e-05 27.8958 0.979231 28.875 2.18748 28.875Z"
								fill="#EFF6FE"
							></path>
							<path d="M12.8 49V7H34.7516L45.2 17.4484V49H12.8Z" fill="white"></path>
							<path
								d="M33.6747 7.60002C34.2052 7.60002 34.7139 7.81074 35.0889 8.18581L44.0142 17.111C44.3892 17.4861 44.6 17.9948 44.6 18.5253V46.4C44.6 47.5046 43.7045 48.4 42.6 48.4H15.4C14.2954 48.4 13.4 47.5046 13.4 46.4V9.60002C13.4 8.49545 14.2954 7.60002 15.4 7.60002H33.6747ZM35.5857 6.98581C35.2107 6.61074 34.702 6.40002 34.1715 6.40002H14.2C13.0954 6.40002 12.2 7.29545 12.2 8.40002V47.6C12.2 48.7046 13.0954 49.6 14.2 49.6H43.8C44.9045 49.6 45.8 48.7046 45.8 47.6V18.0285C45.8 17.498 45.5892 16.9893 45.2142 16.6142L35.5857 6.98581Z"
								fill="#E2EAF3"
							></path>
							<path d="M34.4 17.8V7H34.7516L45.2 17.4484V17.8H34.4Z" fill="white"></path>
							<path
								d="M35 8.09682L44.1032 17.2H37C35.8955 17.2 35 16.3046 35 15.2V8.09682ZM35 6.40002H33.8V16.4C33.8 17.5046 34.6955 18.4 35.8 18.4H45.8V17.2L35 6.40002Z"
								fill="#E2EAF3"
							></path>
							<path d="M32.6 29.4028L29 32.8L34.4648 38.8H38.6V35.2L32.6 29.4028Z" fill="#7AADF0"></path>
							<path
								d="M36.2 22C35.5635 22 34.9531 22.2529 34.503 22.7029C34.0529 23.153 33.8 23.7635 33.8 24.4C33.8 25.0365 34.0529 25.647 34.503 26.0971C34.9531 26.5471 35.5635 26.8 36.2 26.8C36.8365 26.8 37.447 26.5471 37.8971 26.0971C38.3472 25.647 38.6 25.0365 38.6 24.4C38.6 23.7635 38.3472 23.153 37.8971 22.7029C37.447 22.2529 36.8365 22 36.2 22ZM36.2 38.8H19.4V34L25.4 28L36.2 38.8Z"
								fill="#B5DEFF"
							></path>
						</g>
						<defs>
							<clipPath id="clip0_504_30600">
								<rect width="56" height="56" fill="white"></rect>
							</clipPath>
						</defs>
					</svg>
					<div class="mt-3">No Data found</div>
				</div>
			</div>
		);
	}

	// getcardDetails(is_subscribed, status, deleted, is_default) {
	// 	return (
	// 		this.state.cards_list && this.state.cards_list.length > 0 ? (
	// 			<div className="card">
	// 				<div className="top-text">Card Details</div>
	// 				<div className="card-details">
	// 					{this.state.cards_list.map((data, key) => (
	// 						<div className="single-product" key={key}>
	// 							<div className="pull-left">
	// 								<div className="bottom-text">{data.card_type || ""}</div>
	// 								<div className="bottom-text">{data.card_last_fourdigit || ""}</div>
	// 								<div className="bottom-text">{data.card_holder_name || ""}</div>
	// 							</div>
	// 							<div className="pull-right">
	// 								<div className="bottom-text">Valid Thru</div>
	// 								<div className="bottom-text">
	// 									{data.cancelled_date ? data.cancelled_date : "N/A"}
	// 								</div>
	// 							</div>
	// 						</div>
	// 					))}
	// 				</div>
	// 			</div>
	// 		) : (
	// 			<div className="single-product card">
	// 				<div className="top-text">Card Details</div>
	// 				<div className="bottom-text">NA</div>
	// 			</div>
	// 		)
	// 	);
	// }

	getcardDetails() {
		return this.state.cards_list && this.state.cards_list.length > 0 ? (
			<div className="col-lg-4 col-md-4 col-sm-4 col-xs-6">
				<div className="single-product" style={{ marginBottom: "10px" }}>
					<div className="top-text">Card Details</div>
					<div className="bottom-text">
						<span>
							{this.state.cards_list
								.map((data) => data.card_last_fourdigit.toString().slice(-4))
								.filter(Boolean)
								.join(", ")}
						</span>
					</div>
				</div>
			</div>
		) : (
			<div className="col-lg-4 col-md-4 col-sm-4 col-xs-6">
				<div className="single-product card">
					<div className="top-text">Card Details</div>
					<div className="bottom-text">NA</div>
				</div>
			</div>
		);
	}



	getRevenue() {
		if (this.state.currency.length > 0) {
			return (
				<div className="bottom-text">{this.state.currency[0].amount || 0}</div>
				// <select class="form-control customer_form-control">
				//   {this.state.currency.map((currency, key) => (
				//     <option value="">
				//       {currency.symbol} {currency.amount}
				//     </option>
				//   ))}
				// </select>
			);
		}
	}
	formatBytes(bytes) {
		if (!+bytes) return "0.00 B";
		var size = "GB";
		return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} ${size}`;
	}

	showDeleteHandler = (email) => {
		this.setState((state) => {
			return {
				...state,
				showWarning: true,
				deleteEmail: email,
			};
		});
	};

	getBandwidthDetails() {
		const debug = this.getQueryString();
		var studioId = this.props.match.params.studioId;
		const firstdate = moment().startOf("month").format("YYYY-MM-DD");
		let bodyParams = {
			studio_id: this.props.match.params.studioId,
			created_date: firstdate,
			debug,
		};
		const compressedPostData = debug ? JSON.stringify(bodyParams) : pako.gzip(JSON.stringify(bodyParams));
		fetch(process.env.REACT_APP_CRM + "/muvi5/get-bandwidth", {
			method: "POST",
			body: compressedPostData,
		})
			.then((response) => (debug ? response.json() : response.arrayBuffer())) // Get response body as ArrayBuffer
			.then((buffer) => {
				const findresponse = debug ? buffer : actionFunction.decompressjsondata(buffer);
				if (findresponse && findresponse.code == 200) {
					var total_bandwidth = this.formatBytes(findresponse.result[0].total_bandwidth);
					this.setState({
						bandwidth: total_bandwidth,
						get_bandwidth_api: 1,
					});
				}
			}) /*
			.then((Response) => Response.json())
			.then((findresponse) => {
				if (findresponse.code == 200) {
					var total_bandwidth = this.formatBytes(findresponse.result[0].total_bandwidth);
					console.log(total_bandwidth, "BAndwith Adta");
					this.setState({
						bandwidth: total_bandwidth,
						get_bandwidth_api: 1,
					});
				}
			})*/
			.catch((error) => {
				console.error("There was a problem with the fetch operation:", error);
			});
	}

	onChangeaction(propertyName, event) {
		if (propertyName == "andr_fcm_key") {
			propertyName = event.target.value;
			this.setState({ andr_fcm_key: propertyName });
		}
		if (propertyName == "andr_deep_link_code") {
			propertyName = event.target.value;
			this.setState({ andr_deep_link_code: propertyName });
		}
		if (propertyName == "andr_client_id") {
			propertyName = event.target.value;
			this.setState({ andr_client_id: propertyName });
		}
		if (propertyName == "andr_client_secret") {
			propertyName = event.target.value;
			this.setState({ andr_client_secret: propertyName });
		}
		if (propertyName == "andr_force_update_version") {
			propertyName = event.target.value;
			this.setState({ andr_force_update_version: propertyName });
		}
		if (propertyName == "andr_refresh_token") {
			propertyName = event.target.value;
			this.setState({ andr_refresh_token: propertyName });
		}
		if (propertyName == "ios_fcm_key") {
			propertyName = event.target.value;
			this.setState({ ios_fcm_key: propertyName });
		}
		if (propertyName == "ios_deep_link_code") {
			propertyName = event.target.value;
			this.setState({ ios_deep_link_code: propertyName });
		}
		if (propertyName == "ios_secret_code") {
			propertyName = event.target.value;
			this.setState({ ios_secret_code: propertyName });
		}
		if (propertyName == "ios_force_update_version") {
			propertyName = event.target.value;
			this.setState({ ios_force_update_version: propertyName });
		}
		if (propertyName == "ios_mode") {
			propertyName = event.target.value;
			this.setState({ ios_mode: propertyName });
		}
		if (propertyName == "roku_sandbox_key") {
			propertyName = event.target.value;
			this.setState({ roku_sandbox_key: propertyName });
		}
		if (propertyName == "roku_production_key") {
			propertyName = event.target.value;
			this.setState({ roku_production_key: propertyName });
		}
		if (propertyName == "roku_force_update_version") {
			propertyName = event.target.value;
			this.setState({ roku_force_update_version: propertyName });
		}
		if (propertyName == "roku_mode") {
			propertyName = event.target.value;
			this.setState({ roku_mode: propertyName });
		}
	}
	android_edit() {
		{
			this.state.user_permission == 1
				? this.setState({ android_view_state: 0 })
				: alert("You don't have sufficient permission to edit this form.");
		}
	}
	ios_edit() {
		{
			this.state.user_permission == 1
				? this.setState({ ios_view_state: 0 })
				: alert("You don't have sufficient permission to edit this form.");
		}
	}
	roku_edit() {
		{
			this.state.user_permission == 1
				? this.setState({ roku_view_state: 0 })
				: alert("You don't have sufficient permission to edit this form.");
		}
	}
	apple_edit() {
		{
			this.state.user_permission == 1
				? this.setState({ apple_view_state: 0 })
				: alert("You don't have sufficient permission to edit this form.");
		}
	}
	fire_edit() {
		{
			this.state.user_permission == 1
				? this.setState({ fire_view_state: 0 })
				: alert("You don't have sufficient permission to edit this form.");
		}
	}
	updateAppSettings() {
		var andoid_chk = (this.state.andr_force_update_version = this.state.andr_force_update_version.replace(
			/[^0-9\.]/g,
			""
		));
		var andoid_chk = andoid_chk[andoid_chk.length - 1];
		this.state.andr_force_update_version =
			andoid_chk == "."
				? this.state.andr_force_update_version.slice(0, -1)
				: this.state.andr_force_update_version;
		document.getElementById("android_form_update").innerHTML = "Sending....";
		document.getElementById("android_form_update").disabled = true;
		const fd = new FormData();
		fd.append("andr_fcm_key", this.state.andr_fcm_key);
		fd.append("andr_deep_link_code", this.state.andr_deep_link_code);
		fd.append("andr_client_id", this.state.andr_client_id);
		fd.append("andr_client_secret", this.state.andr_client_secret);
		fd.append("andr_force_update_version", this.state.andr_force_update_version);
		fd.append("andr_refresh_token", this.state.andr_refresh_token);
		fd.append("android_fcm_id", this.state.android_id);
		fd.append("android_config_id", this.state.android_config_id);
		fd.append("android_version_code_id", this.state.android_version_code_id);
		fetch(
			this.state.apiUrl +
			"/adminRest/AppSettings/studioId/" +
			this.props.match.params.studioId +
			"/userAuthKey/" +
			this.state.userAuthKey,
			{
				method: "POST",
				dataType: "json",
				body: fd,
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				console.log(findresponse);
				document.getElementById("android_form_update").disabled = false;
				document.getElementById("android_form_update").innerHTML = "Update";
				this.setState({ android_view_state: 1 });
				if (findresponse.code == 200) {
					this.setState({ message: findresponse.msg }, function () { });
				} else {
					this.setState({ message: findresponse.msg });
				}
			});
	}
	updateiosAppSettings() {
		var ios_chk = (this.state.ios_force_update_version = this.state.ios_force_update_version.replace(
			/[^0-9\.]/g,
			""
		));
		var ios_chk = ios_chk[ios_chk.length - 1];
		this.state.ios_force_update_version =
			ios_chk == "." ? this.state.ios_force_update_version.slice(0, -1) : this.state.ios_force_update_version;
		document.getElementById("ios_form_update").innerHTML = "Sending....";
		document.getElementById("ios_form_update").disabled = true;
		const fd = new FormData();
		fd.append("ios_fcm_key", this.state.ios_fcm_key);
		fd.append("ios_deep_link_code", this.state.ios_deep_link_code);
		fd.append("ios_secret_code", this.state.ios_secret_code);
		fd.append("ios_force_update_version", this.state.ios_force_update_version);
		fd.append("ios_mode", this.state.ios_mode);
		fd.append("ios_fcm_id", this.state.android_id);
		fd.append("ios_config_id", this.state.ios_config_id);
		fd.append("ios_version_code_id", this.state.ios_version_code_id);
		fetch(
			this.state.apiUrl +
			"/adminRest/AppSettings/studioId/" +
			this.props.match.params.studioId +
			"/userAuthKey/" +
			this.state.userAuthKey,
			{
				method: "POST",
				dataType: "json",
				body: fd,
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				console.log(findresponse);
				document.getElementById("ios_form_update").disabled = false;
				document.getElementById("ios_form_update").innerHTML = "Update";
				this.setState({ ios_view_state: 1 });
				if (findresponse.code == 200) {
					this.setState({ message: findresponse.msg }, function () { });
				} else {
					this.setState({ message: findresponse.msg });
				}
			});
	}
	updateRokuAppSettings() {
		var roku_chk = (this.state.roku_force_update_version = this.state.roku_force_update_version.replace(
			/[^0-9\.]/g,
			""
		));
		var roku_chk = roku_chk[roku_chk.length - 1];
		this.state.roku_force_update_version =
			roku_chk == "." ? this.state.roku_force_update_version.slice(0, -1) : this.state.roku_force_update_version;
		document.getElementById("roku_form_update").innerHTML = "Sending....";
		document.getElementById("roku_form_update").disabled = true;
		const fd = new FormData();
		fd.append("roku_config_id", this.state.roku_config_id);
		fd.append("roku_sandbox_key", this.state.roku_sandbox_key);
		fd.append("roku_production_key", this.state.roku_production_key);
		fd.append("roku_version_code_id", this.state.roku_version_code_id);
		fd.append("roku_force_update_version", this.state.roku_force_update_version);
		fd.append("roku_mode", this.state.roku_mode);
		fetch(
			this.state.apiUrl +
			"/adminRest/AppSettings/studioId/" +
			this.props.match.params.studioId +
			"/userAuthKey/" +
			this.state.userAuthKey,
			{
				method: "POST",
				dataType: "json",
				body: fd,
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				console.log(findresponse);
				document.getElementById("roku_form_update").disabled = false;
				document.getElementById("roku_form_update").innerHTML = "Update";
				this.setState({ roku_view_state: 1 });
				if (findresponse.code == 200) {
					this.setState({ message: findresponse.msg }, function () { });
				} else {
					this.setState({ message: findresponse.msg });
				}
			});
	}

	getViewAndroidInfo() {
		return (
			<div class="row">
				<div class="col-md-12">
					<div class="app-info">
						<span>FCM Key</span>
						<p>{this.state.andr_fcm_key ? this.state.andr_fcm_key : "NA"}</p>
					</div>
				</div>
				<div class="col-md-12">
					<div class="app-info">
						<span>Deeplink Code</span>
						<p>{this.state.andr_deep_link_code ? this.state.andr_deep_link_code : "NA"}</p>
					</div>
				</div>
				<div class="col-md-4">
					<div class="app-info">
						<span>Client ID</span>
						<p>{this.state.andr_client_id ? this.state.andr_client_id : "NA"} </p>{" "}
					</div>
				</div>
				<div class="col-md-4">
					<div class="app-info">
						<span>Client Secret</span>
						<p>{this.state.andr_client_secret ? this.state.andr_client_secret : "NA"}</p>
					</div>
				</div>
				<div class="col-md-4">
					<div class="app-info">
						<span>Refresh Token</span>
						<p> {this.state.andr_refresh_token ? this.state.andr_refresh_token : "NA"}</p>
					</div>
				</div>
				<div class="col-md-4">
					<div class="app-info">
						<span>Force Update For Version</span>
						<p>{this.state.andr_force_update_version ? this.state.andr_force_update_version : "NA"} </p>
					</div>
				</div>
			</div>
		);
	}
	getEditAndroidInfo() {
		return (
			<div class="row">
				<div class="col-md-12">
					<div class="app-info">
						<span>FCM Key</span>
						<div class="col-md-12">
							<input
								type="text"
								id="fcm_key"
								name="andr_fcm_key"
								class="form-control per_new_fields app-field-lbl"
								placeholder="Enter FCM Key"
								value={this.state.andr_fcm_key}
								onChange={this.onChangeaction.bind(this, "andr_fcm_key")}
							/>
						</div>
					</div>
					<div class="app-info">
						<span>Deeplink Code:</span>
						<div class="col-md-12">
							<textarea
								id="deep_link"
								name="andr_deep_link_code"
								class="form-control per_new_fields app-field-lbl"
								placeholder="Enter Deeplinking Code"
								value={this.state.andr_deep_link_code}
								onChange={this.onChangeaction.bind(this, "andr_deep_link_code")}
							></textarea>
						</div>
					</div>
					<span class="job_title shared_secret app-label">In-app Credentials:</span>
					<div class="secret_ky">
						<div class="app-info">
							<span>Client ID:</span>
							<div class="col-md-12">
								<input
									type="text"
									id="sandbox_key"
									name="andr_client_id"
									class="form-control per_new_fields app-field-lbl"
									placeholder="Enter Client ID"
									value={this.state.andr_client_id}
									onChange={this.onChangeaction.bind(this, "andr_client_id")}
								/>
							</div>
						</div>
						<div class="app-info">
							<span>Client Secret:</span>
							<div class="col-md-12">
								<input
									type="text"
									id="production_key"
									name="andr_client_secret"
									class="form-control per_new_fields app-field-lbl"
									placeholder="Enter Client Secret"
									value={this.state.andr_client_secret}
									onChange={this.onChangeaction.bind(this, "andr_client_secret")}
								/>
							</div>
						</div>
						<div class="app-info">
							<span>Refresh Token:</span>
							<div class="col-md-12">
								<input
									type="text"
									id="andr_refresh_token"
									name="andr_refresh_token"
									class="form-control per_new_fields app-field-lbl"
									placeholder="Enter Refresh Token"
									value={this.state.andr_refresh_token}
									onChange={this.onChangeaction.bind(this, "andr_refresh_token")}
								/>
							</div>
						</div>
					</div>
					<div class="app-info">
						<span>Force Update For Version:</span>
						<div class="col-md-12">
							<input
								type="text"
								id="andr_code"
								name="andr_force_update_version"
								class="form-control per_new_fields force_update_version app-field-lbl"
								placeholder="Enter Version Code"
								value={this.state.andr_force_update_version}
								onChange={this.onChangeaction.bind(this, "andr_force_update_version")}
								onKeyUp={this.handleKeyUp}
							/>
						</div>
					</div>
				</div>
				<span class="app_update" id="android_update">
					<a
						a
						href="javascript:void(0);"
						id="android_form_update"
						class="btn btn-trans Medium"
						onClick={() => this.updateAppSettings()}
					>
						{" "}
						Update
					</a>
				</span>
			</div>
		);
	}
	getViewiosInfo() {
		return (
			<div class="row">
				<div class="col-md-12">
					<div class="app-info">
						<span>FCM Key</span>
						<p>{this.state.ios_fcm_key ? this.state.ios_fcm_key : "NA"}</p>
					</div>
				</div>
				<div class="col-md-12">
					<div class="app-info">
						<span>Deeplink Code</span>
						<p>{this.state.ios_deep_link_code ? this.state.ios_deep_link_code : "NA"}</p>
					</div>
				</div>
				<div class="col-md-4">
					<div class="app-info">
						<span>Shared Secret Key</span>
						<p> {this.state.ios_secret_code ? this.state.ios_secret_code : "NA"}</p>
					</div>
				</div>
				<div class="col-md-4">
					<div class="app-info">
						<span>Mode</span>
						<p>
							{" "}
							{this.state.ios_mode == "sandbox" ? (
								"Sandbox"
							) : this.state.ios_mode == "production" ? (
								"Production"
							) : (
								<p>NA</p>
							)}
						</p>
					</div>
				</div>
				<div class="col-md-6">
					<div class="app-info">
						<span>Force Update For Version</span>
						<p>{this.state.ios_force_update_version ? this.state.ios_force_update_version : "NA"}</p>
					</div>
				</div>
			</div>
		);
	}
	getEditiosInfo() {
		return (
			<div class="row">
				<div class="col-md-12">
					<div class="app-info">
						<span>FCM Key</span>
						<div class="col-md-12">
							<input
								type="text"
								id="fcm_key"
								name="ios_fcm_key"
								class="form-control per_new_fields app-field-lbl"
								placeholder="Enter FCM Key"
								value={this.state.ios_fcm_key}
								onChange={this.onChangeaction.bind(this, "ios_fcm_key")}
							/>
						</div>
					</div>
				</div>
				<div class="col-md-12">
					<div class="app-info">
						<span>Deeplink Code</span>
						<div class="col-md-12">
							<textarea
								id="deep_link"
								name="ios_deep_link_code"
								class="form-control per_new_fields app-field-lbl"
								placeholder="Enter Deeplinking Code"
								value={this.state.ios_deep_link_code}
								onChange={this.onChangeaction.bind(this, "ios_deep_link_code")}
							></textarea>
						</div>
					</div>
				</div>
				<div class="col-md-4">
					<div class="app-info">
						<span>Shared Secret Key</span>
						<div class="col-md-12">
							<input
								type="text"
								id="key"
								name="ios_secret_code"
								class="form-control per_new_fields app-field-lbl"
								placeholder="Enter Key"
								value={this.state.ios_secret_code}
								onChange={this.onChangeaction.bind(this, "ios_secret_code")}
							/>
						</div>
					</div>
				</div>
				<div class="col-md-4">
					<div class="app-info">
						<span>Mode</span>
						<div class="col-md-12 radio_custom">
							<div class="radio_custom per_new_fields">
								<div class="radio-inline feature-check">
									<input
										class="valid_fld app-field-lbl"
										id="ios_mode1"
										value="sandbox"
										type="radio"
										name="ios_mode"
										onChange={this.onChangeaction.bind(this, "ios_mode")}
										checked={this.state.ios_mode === "sandbox"}
									/>
									<label for="ios_mode1">
										<span></span>Sandbox
									</label>
								</div>
								<div class="radio-inline feature-check">
									<input
										class="valid_fld app-field-lbl"
										id="ios_mode2"
										value="production"
										type="radio"
										name="ios_mode"
										onChange={this.onChangeaction.bind(this, "ios_mode")}
										checked={this.state.ios_mode === "production"}
									/>
									<label for="ios_mode2">
										<span></span>Production
									</label>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-6">
					<div class="app-info">
						<span>Force Update For Version</span>
						<div class="col-md-12">
							<input
								type="text"
								id="ios_code"
								name="ios_force_update_version"
								class="force_update_version form-control per_new_fields app-field-lbl"
								placeholder="Enter Version Code"
								value={this.state.ios_force_update_version}
								onChange={this.onChangeaction.bind(this, "ios_force_update_version")}
								onKeyUp={this.handleKeyUp}
							/>
						</div>
					</div>
				</div>

				<span class="app_update" id="android_update">
					<a
						a
						href="javascript:void(0);"
						id="ios_form_update"
						class="btn btn-trans Medium"
						onClick={() => this.updateiosAppSettings()}
					>
						{" "}
						Update
					</a>
				</span>
			</div>
		);
	}
	getViewRokuInfo() {
		return (
			<div class="row">
				<div class="col-md-4">
					<div class="app-info">
						<span>Shared Secret Key</span>
						<p>Add Credentials</p>
					</div>
				</div>
				<div class="col-md-4">
					<div class="app-info">
						<span>Sandbox Key</span>
						<p> {this.state.roku_sandbox_key ? this.state.roku_sandbox_key : "NA"}</p>
					</div>
				</div>
				<div class="col-md-4">
					<div class="app-info">
						<span>Production Key</span>
						<p> {this.state.roku_production_key ? this.state.roku_production_key : "NA"}</p>
					</div>
				</div>
				<div class="col-md-4">
					<div class="app-info">
						<span>Mode</span>
						<p>
							{" "}
							{this.state.roku_mode == "sandbox" ? (
								"Sandbox"
							) : this.state.roku_mode == "production" ? (
								"Production"
							) : (
								<p>NA</p>
							)}
						</p>
					</div>
				</div>
				<div class="col-md-4">
					<div class="app-info">
						<span>Force Update For Version</span>
						<p> {this.state.roku_force_update_version ? this.state.roku_force_update_version : "NA"}</p>
					</div>
				</div>
			</div>
		);
	}
	getEditRokuInfo() {
		return (
			<div class="row">
				<div class="col-md-4">
					<div class="app-info">
						<span>Shared Secret Key</span>
						<p>Add Credentials</p>
					</div>
				</div>
				<div class="col-md-4">
					<div class="app-info">
						<span>Sandbox Key</span>
						<div class="col-md-12">
							<input
								type="text"
								id="sandbox_key"
								name="roku_sandbox_key"
								class="form-control per_new_fields app-field-lbl"
								placeholder="Enter Sandbox Key"
								value={this.state.roku_sandbox_key}
								onChange={this.onChangeaction.bind(this, "roku_sandbox_key")}
							/>
						</div>
					</div>
				</div>
				<div class="col-md-4">
					<div class="app-info">
						<span>Production Key</span>
						<div class="col-md-12">
							<input
								type="text"
								id="production_key"
								name="roku_production_key"
								class="form-control per_new_fields app-field-lbl"
								placeholder="Enter Production Key"
								value={this.state.roku_production_key}
								onChange={this.onChangeaction.bind(this, "roku_production_key")}
							/>
						</div>
					</div>
				</div>
				<div class="col-md-4">
					<div class="app-info">
						<span>Mode</span>
						<div class="col-md-12">
							<div class="radio_custom per_new_fields">
								<div class="radio-inline feature-check">
									<input
										class="valid_fld app-field-lbl"
										id="roku_mode1"
										value="sandbox"
										type="radio"
										name="roku_mode"
										onChange={this.onChangeaction.bind(this, "roku_mode")}
										checked={this.state.roku_mode === "sandbox"}
									/>
									<label for="roku_mode1">
										<span></span>Sandbox
									</label>
								</div>
								<div class="radio-inline feature-check">
									<input
										class="valid_fld app-field-lbl"
										id="roku_mode2"
										value="production"
										type="radio"
										name="roku_mode"
										onChange={this.onChangeaction.bind(this, "roku_mode")}
										checked={this.state.roku_mode === "production"}
									/>
									<label for="roku_mode2">
										<span></span>Production
									</label>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-4">
					<div class="app-info">
						<span>Force Update For Version</span>
						<div class="col-md-12">
							<input
								type="text"
								id="roku_code"
								name="roku_force_update_version"
								class="force_update_version form-control per_new_fields app-field-lbl"
								placeholder="Enter Version Code"
								value={this.state.roku_force_update_version}
								onChange={this.onChangeaction.bind(this, "roku_force_update_version")}
								onKeyUp={this.handleKeyUp}
							/>
						</div>
					</div>
				</div>

				<span class="app_update" id="roku_update">
					<a
						a
						href="javascript:void(0);"
						id="roku_form_update"
						class="btn btn-trans Medium"
						onClick={() => this.updateRokuAppSettings()}
					>
						{" "}
						Update
					</a>
				</span>
			</div>
		);
	}

	getMuviOwnerShipDetails() {
		//let crmStaging = process.env.REACT_APP_CRM + "/crm/details/" + this.props.match.params.studioId;
		const debug = this.getQueryString();
		let columnsfetch = {
			customer_id: this.props.match.params.studioId,
			debug,
		};
		const compressedPostData = debug ? JSON.stringify(columnsfetch) : pako.gzip(JSON.stringify(columnsfetch));
		fetch(process.env.REACT_APP_CRM + "/crm/details", {
			method: "POST",
			body: compressedPostData, //JSON.stringify(columnsfetch),
		})
			.then((response) => (debug ? response.json() : response.arrayBuffer())) // Get response body as ArrayBuffer
			.then((buffer) => {
				const data = debug ? buffer : actionFunction.decompressjsondata(buffer);
				if (data) {
					this.setState({
						...this.state,
						data: {
							...this.state.data,
							...data,
						},
					});
					// this.getCrmNotes(this.state.data.customer_tattle_uuid);
				} else {
					//console.error("API error! Response data:", data);
					this.setState({
						muvi_ownership: [], // Set muvi_ownership to empty array on error
						loader: 0,
					});
				}
			}) /*
			.then((data) => {
				if (data && data.code === 200 && data.data) {
					//console.log(data.data[0], "Data");
					this.setState({
						muvi_ownership: data.data[0].muvi_ownership || [], // Use empty array as fallback if ownership_details is not available
						loader: 0,
						crmdata: data.data[0],
						customer_tattle_uuid: data.data[0].customer_tattle_uuid,
						logo: data.data[0].logo,
					});
					this.getCrmNotes(data.data[0].customer_tattle_uuid);
					this.getCustomerDetails(data.data[0].enterprise_api_gateway_url);
					this.otherBillingDetails(data.data[0].enterprise_api_gateway_url);
					this.showLoginDetails(data.data[0].enterprise_api_gateway_url);
					this.showUploadDetails(data.data[0].enterprise_api_gateway_url);
				} else {
					//console.error("API error! Response data:", data);
					this.setState({
						muvi_ownership: [], // Set muvi_ownership to empty array on error
						loader: 0,
					});
				}
			})*/
			.catch((error) => {
				console.error("Fetch error:", error); // Log any fetch errors
				this.setState({
					muvi_ownership: [], // Set muvi_ownership to empty array on error
					loader: 0,
				});
			});
	}

	/**
	 *
	 * Right Sidebar
	 */

	getCrmNotes = (id) => {
		const output = fetch(`${process.env.REACT_APP_tattle_api}/notes/list`, {
			method: "POST",
			body: JSON.stringify({
				customer_tattle_uuid: Number(this.state.data.customer_tattle_uuid),
				attribute_set_key: "crm",
				app_token: process.env.REACT_APP_tattle_token,
				attribute_set_type: 5,
				// customer_tattle_uuid: id,
				// attribute_set_key: "crm",
				// app_token: this.props.match.params.appToken,
				// attribute_set_type: 20,
			}),
		});

		output
			.then((i) => {
				return i.json();
			})
			.then((out) => {
				this.setState({
					crmNotes: out,
				});
			})
			.catch((error) => {
				console.error("Fetch error:", error.message);
				// Handle fetch error
			});
	};
	addChatNote = (chatData) => {
		this.setState({
			noteContent: chatData,
		});
	};

	onChange(event) {
		this.setState({
			userType: event.target.value,
		});
	}

	noteAdd = (e) => {
		e.preventDefault();
		this.setState({
			noteAdding: 1,
			editId: this.state.editId + 1,
		});
		const mentionIds = this.state.noteContent.mentioned_data;
		//console.log("note-", this.state.noteContent.chat_note.html_content);
		// console.log("user_uuid", this.state.userUUID);
		// console.log("app_token", this.state.customer_details.app_token);
		// console.log("customer_id", this.props.match.params.appToken);
		//console.log("customer_tattle_uuid  :", this.state.customer_tattle_uuid);
		/*
		if (this.state.userType == "" && this.state.userType.length == 0) {
			this.setState({
				noteError: true,
				noteAdding: 0,
			});
			return false;
		} else {
			this.setState({
				noteError: false,
				noteAdding: 0,
			});
		}
		*/
		if (this.state.noteContent && this.state.noteContent.chat_note.html_content == "") {
			this.setState({
				noteError: true,
				noteAdding: 0,
			});
			return false;
		} else {
			this.setState({
				noteError: false,
				noteContent: "",
				note: this.state.noteContent.chat_note.html_content,
			});

			setTimeout(() => {
				//
				//apitattle.muvi.com/note/create
				fetch(`${process.env.REACT_APP_tattle_api}/note/create`, {
					method: "POST",
					body: JSON.stringify({
						attribute_set_key: "crm",
						app_token: process.env.REACT_APP_tattle_token,
						customer_tattle_uuid: this.state.data.customer_tattle_uuid,
						user_uuid: this.state.userUUID,
						note_content: this.state.note,
						note_content_json:
							this.state.noteContent.chat_note.draft_js_content &&
							this.state.noteContent.chat_note.draft_js_content,
						mention: mentionIds && mentionIds,
						note_type: this.state.userType,
						attribute_set_type: 5,
					}),
				})
					.then((item) => {
						return item.json();
					})
					.then((data) => {
						//console.log("Insert Data -", data);
						this.setState({
							noteAdding: 0,
						});
						//this.state.muvi_ownership.customer_tattle_uuid
						this.getCrmNotes(this.props.match.params.studioId);
						this.setState({
							note: "",
						});
					})
					.catch((error) => {
						console.error("Fetch error:", error.message);
						// Handle fetch error
					});
			}, 1000);
		}
	};

	asyncApiCall = async (evt, url, key) => {
		if (evt && this.state.asyncApiData[key].length > 0) {
			return this.state.asyncApiData[key].filter((item) => item.label.toLowerCase().includes(evt.toLowerCase()));
		}
		try {
			const fetchResponse = await fetch(url).catch((err) => console.log(err.message));
			const rdata = await fetchResponse.json();
			if (rdata.code === 200) {
				const { data } = rdata;
				let salsdata = data.map((item) => ({
					label: item.name,
					value: item.user_uuid,
					image: item.attachment,
				}));

				this.setState((state) => {
					return {
						...state,
						asyncApiData: { ...state.asyncApiData, [key]: salsdata },
					};
				});
				return salsdata;
			}
		} catch (err) {
			console.log(err.message);
		}
	};

	ownerShipHandler = (name, evt, url) => {
		let ownership = { ...this.state.updateOwnerShip };
		let tempvalue = { ...this.state.customSelectValue };
		if (evt) {
			ownership = {
				...ownership,
				[name]: evt.value,
			};
			tempvalue = {
				...tempvalue,
				[name]: { label: evt.label, value: evt.value, image: evt.image },
			};
		} else {
			ownership = {
				...ownership,
				[name]: "",
			};
			tempvalue = {
				...tempvalue,
				[name]: {
					label: evt ? evt.label : "",
					value: evt ? evt.value : "",
					image: evt ? evt.image : "",
				},
			};
		}

		this.setState((state) => {
			return {
				...state,
				updateOwnerShip: ownership,
				customSelectValue: tempvalue,
			};
		});
	};

	ownerShipSubmitHandler = async (evt) => {
		evt.preventDefault();
		let newowner = { ...this.state.updateOwnerShip };

		if (this.state.data.hasOwnProperty("account_manager") && this.state.data.account_manager) {
			newowner = {
				account_manager: this.state.data.account_manager,
				...newowner,
			};
		}
		if (this.state.data.hasOwnProperty("sales_manager") && this.state.data.sales_manager) {
			newowner = { sales_manager: this.state.data.sales_manager, ...newowner };
		}

		if (this.state.data.hasOwnProperty("tse_owner") && this.state.data.tse_owner) {
			newowner = { tse_owner: this.state.data.tse_owner, ...newowner };
		}

		try {
			if (Object.keys(newowner).length > 0) {
				const userUUID = Cookies.get("muvi_useruuid");
				const responsedata = await fetch(`${process.env.REACT_APP_CRM}/muvi6/manage-muvi-ownership`, {
					method: "POST",
					body: JSON.stringify({
						product_key: "3D28C83C85544F0D9517DD2E7C7EEDAA",
						customer_id: this.props.match.params.studioId,
						last_updated_by: userUUID,
						...newowner,
						is_live: false,
					}),
				});
				const response = await responsedata.json();
				if (response && response.code === 200) {
					// Fill blank objects with available data
					toast.success(response.message, {
						position: "top-right",
						autoClose: 1000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: "light",
						transition: Bounce,
					});
					this.setState((state) => {
						return {
							...state,
							data: {
								...state.data,
								...this.state.updateOwnerShip,
							},
						};
					});
				} else {
					const errorMessage = response && response.message ? response.message : "An error occurred";
					toast.error(errorMessage, {
						position: "top-right",
						autoClose: 1000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: "light",
						transition: Bounce,
					});
				}
			}
			const backdrop = document.querySelector(".modal-backdrop");
			backdrop.style.display = "none";
			this.showmodalref.current.classList.remove("show");
			this.showmodalref.current.style.display = "none";
			// after modal Close pages are workable
			document.body.classList.remove("modal-open");
		} catch (err) {
			console.log(err.message);
		}
	};

	userLists() {
		fetch(`${process.env.REACT_APP_CRM}/user-list`, {
			method: "POST",
		})
			.then((resp) => {
				return resp.json();
			})
			.then((data) => {
				if (data.code == 200) {
					this.setState({
						userList: data.data,
					});
					const userData = data.data;
					for (const key in userData) {
						if (userData.hasOwnProperty(key)) {
							const user = userData[key];
							if (user.emp_id == this.state.userId) {
								//let userUuid = user.user_uuid;
								//console.log(user.user_uuid, "userUUID");
								this.setState({
									userUUID: user.user_uuid,
								});
								break;
							}
						}
					}
				}
			});
	}
	showMuviOwnerShipHandler = () => {
		this.showmodalref.current.classList.add("show");
		this.showmodalref.current.classList.add("in");
	};

	componentDidMount() {
		// this.getMuviOwnerShipDetails();

		// this.customerDeepLinking();
		this.getCustomerDetails();
		this.userLists();
		document.title = "Intranet | Customer Details";
		if (!localStorage.getItem("userLogin")) {
			this.setState({ redirect: true });
		}
	}

	componentWillUnmount() {
		clearTimeout(this.timer);
	}
	// To rerender the whole component
	componentDidUpdate(prevProps, prevState) {
		if (this.state.shouldRerender !== prevState.shouldRerender) {
			// Reset the rerender flag to prevent continuous rerendering
			this.setState({ shouldRerender: false });
		}
	}

	saveOtherContacts = async (contact) => {
		let otherContacts = [...this.state.other_contacts];
		if (this.state.isContactEdit) {
			otherContacts[this.state.contactIndex] = { ...contact };
		} else {
			otherContacts.push(contact);
		}

		const request = {
			customer_id: this.props.match.params.studioId,
			other_contacts: contact,
		};
		try {
			const response = await fetch(process.env.REACT_APP_CRM + "/muvi6/manage-other-contacts", {
				method: "POST",
				body: JSON.stringify(request),
			});

			const resData = await response.json();

			if (resData.code === 200) {
				this.setState((state) => {
					return {
						...state,
						other_contacts: otherContacts,
						isContactEdit: false,
						contactsEdit: {
							name: "",
							email: "",
							phone_number: "",
							designation: "",
						},
					};
				});
				if (this.contactRef.current) {
					this.contactRef.current.classList.remove("in");
					this.contactRef.current.style.display = "none";
					document.querySelector(".modal-backdrop").classList.remove("in");
					document.querySelector(".modal-backdrop").style.display = "none";
				}
			} else {
				console.log(resData.message);
			}
		} catch (err) {
			console.log(err.message);
		}
	};

	toggleOwnerShipHandler = () => {
		this.setState((state) => {
			return {
				...state,
				isShowOwnerShip: !state.isShowOwnerShip,
			};
		});
	};
	toggleContactShipHandler = () => {
		this.setState((state) => {
			return {
				...state,
				isShowContactShip: !state.isShowContactShip,
			};
		});
	};
	contactEditHandler = (index) => {
		let otherContacts = [...this.state.other_contacts];

		const editcontact = otherContacts[index];
		this.setState((state) => {
			return {
				...state,
				showContactModal: true,
				contactIndex: index,
				isContactEdit: true,
				contactsEdit: editcontact,
			};
		});
	};

	removeEditContact = () => {
		this.setState((state) => {
			return {
				...state,
				isContactEdit: false,
				contactsEdit: {
					name: "",
					email: "",
					phone_number: "",
					designation: "",
				},
				showContactModal: true,
			};
		});
	};

	handleCloseWarningModal = () => {
		this.setState((state) => {
			return {
				...state,
				showWarning: false,
			};
		});
	};

	handleCloseModal = () => {
		this.setState((state) => {
			return {
				...state,
				showContactModal: false,
			};
		});
	};

	getRecentLogo() {
		let companyName = this.state.data && this.state.data.company_name ? this.state.data.company_name : "";
		if (!companyName) {
			const email = (this.state.data && this.state.data.email ? this.state.data.email : "") || "";
			companyName = email.substring(0, email.indexOf("@"));
			if (!companyName) {
				companyName = "Unknown";
			}
		}
        const logo = `https://ui-avatars.com/api/?name=${companyName}&color=ff0000&size=40&background=random`;

		return <img src={logo} alt="Logo" />
	}

	render() {
		if (this.state.redirect) {
			return <Redirect to={"/login"} />;
		}

		const activeUserList = Object.keys(this.state.userList)
			.filter((key) => this.state.userList[key].is_active === 1)
			.reduce((acc, key) => {
				acc[key] = this.state.userList[key];
				return acc;
			}, {});
		console.log("Filtered activeUserList for mentions:", activeUserList);

		return (
			<div>
				{this.state.showContactModal && (
					<CustomModal
						show={this.state.showContactModal}
						handleCloseModal={this.handleCloseModal}
						header="Add New Contact"
						company_name={
							this.state.data && this.state.data.hasOwnProperty("name") ? this.state.data.name : ""
						}
						saveOtherContacts={this.saveOtherContacts}
						contactsEdit={this.state.contactsEdit}
					></CustomModal>
				)}
				{this.state.showWarning && (
					<WarningModal
						showWarning={this.state.showWarning}
						title={this.state.deleteEmail}
						body="Are you sure to remove this contact?"
						handleCloseWarningModal={this.handleCloseWarningModal}
						processDeleteHandler={this.processDeleteHandler}
					/>
				)}

				{this.state.showDelayedComponent && this.ownerShipModal()}

				<Header brecum_main="Account" brecum_name="Account" brecum_page="Account Details" />
				<ToastContainer />
				<div class="right_col fullchatarea">
					<div class="customer-details-area v2 muvi-5 notes crm">
						<div class="product-tab top-new-bar">
							<div class="row">
								<div class="col-md-12 border-end">
									<div class="top-area border-0">
										<div class="row">
											<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
												<ul class="nav nav-tabs" role="tablist">
													<li role="presentation" class="active">
														<a
															href="#overview"
															aria-controls="overview"
															role="tab"
															data-toggle="tab"
															aria-expanded="true"
														>
															Overview
														</a>
													</li>
													<li role="presentation" class="">
														<a
															href="#app"
															aria-controls="app"
															role="tab"
															data-toggle="tab"
															aria-expanded="false"
															onClick={() => this.customerDeepLinking()}
														>
															App Info
														</a>
													</li>
													<li role="presentation" class="">
														<a
															href="#login"
															aria-controls="login"
															role="tab"
															data-toggle="tab"
															aria-expanded="false"
															onClick={() => this.showLoginDetails()}
														>
															Login
														</a>
													</li>
													<li role="presentation" class="">
														<a
															href="#upload"
															aria-controls="upload"
															role="tab"
															data-toggle="tab"
															aria-expanded="false"
															onClick={() => this.showUploadDetails()}
														>
															Upload
														</a>
													</li>
													<NavLink
														to={{
															pathname: "/accounts/list",
															state: {
																pageNumber:
																	this.props.location &&
																	this.props.location.state &&
																	this.props.location.state.pageNumber,
															},
														}}
														className="back-toggle-btn"
													>
														<span
															style={{
																fontSize: "18px",
																lineHeight: "20px",
																color: "rgb(122, 122, 122)",
															}}
														>
															<svg
																stroke="currentColor"
																fill="currentColor"
																stroke-width="0"
																viewBox="0 0 24 24"
																height="1em"
																width="1em"
																xmlns="http://www.w3.org/2000/svg"
															>
																<path d="M21 11H6.414l5.293-5.293-1.414-1.414L2.586 12l7.707 7.707 1.414-1.414L6.414 13H21z"></path>
															</svg>
														</span>
													</NavLink>
												</ul>
											</div>
										</div>
										<div class="tab-content">
											<div role="tabpanel" class="tab-pane active" id="overview">
												<div class="row">
													<div class="col-md-6">
														<div class="profile-area border-0">
															<div class="profile-left">
																<div class="img-box">
																	{this.state.data ? (
																		this.getRecentLogo()
																	) : (
																		<Skeleton count={5} />
																	)}
																</div>
																<div class="text-area">
																	<div class="name">
																		{this.state.data.name && this.state.data.name}
																	</div>
																	<div class="email">
																		<a
																			href={`//${this.state.data.domain}`}
																			target="_blank"
																			className="link_new_domain"
																		>
																			{this.state.data.domain &&
																				this.state.data.domain}
																		</a>
																	</div>
																</div>
															</div>
															<a
																class="add-new"
																data-toggle="modal"
																data-target="#add"
																onClick={this.removeEditContact}
															>
																<svg
																	width="16"
																	height="16"
																	viewBox="0 0 16 16"
																	fill="none"
																	xmlns="http://www.w3.org/2000/svg"
																>
																	<path
																		d="M8 3.33331V12.6666"
																		stroke="white"
																		stroke-width="1.33"
																		stroke-linecap="round"
																		stroke-linejoin="round"
																	></path>
																	<path
																		d="M3.33334 8H12.6667"
																		stroke="white"
																		stroke-width="1.33"
																		stroke-linecap="round"
																		stroke-linejoin="round"
																	></path>
																</svg>
																Add New
															</a>
														</div>
														<div
															class="table-wrap sticky-table"
															style={{ maxHeight: "270px" }}
														>
															<table>
																<thead>
																	<tr>
																		<th width="100">Name</th>
																		{/* <th width="170">Designation</th> */}
																		<th width="150">Email</th>
																		<th width="150">Phone No</th>
																		<th width="80"></th>
																	</tr>
																</thead>
																<tbody>
																	{this.state.other_contacts.map((con, index) => (
																		<MaskTableRow
																			name={con.name}
																			email={con.email}
																			is_edit={con.is_edit}
																			index={index}
																			phone_number={con.phone_number}
																			contactEditHandler={this.contactEditHandler}
																			showDeleteHandler={this.showDeleteHandler}
																		/>
																	))}
																</tbody>
															</table>
														</div>
														<div class="ownership">
															<div class="container-full">
																<div class="row">
																	<div class="col-xs-9">
																		<div class="title" style={{ marginTop: "5px" }}>
																			Muvi Ownership
																		</div>
																	</div>
																	<div class="col-xs-3 text-end">
																		{this.state.storePermission === "1" && (
																			<button
																				data-toggle="modal"
																				data-target="#manageMuviOwnership"
																				class="editprimary-btn"
																				style={{
																					marginRight: 0,
																					marginLeft: "auto",
																				}}
																				onClick={this.showManageOwnership}
																			>
																				<span>
																					{/* icon and colour change */}
																					<svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
																						<g clip-path="url(#clip0_568_443)">
																							<path d="M8.63336 1.50015C8.76468 1.36883 8.92059 1.26466 9.09217 1.19359C9.26375 1.12252 9.44764 1.08594 9.63336 1.08594C9.81908 1.08594 10.003 1.12252 10.1746 1.19359C10.3461 1.26466 10.502 1.36883 10.6334 1.50015C10.7647 1.63147 10.8689 1.78737 10.9399 1.95895C11.011 2.13054 11.0476 2.31443 11.0476 2.50015C11.0476 2.68587 11.011 2.86977 10.9399 3.04135C10.8689 3.21293 10.7647 3.36883 10.6334 3.50015L3.88336 10.2502L1.13336 11.0002L1.88336 8.25015L8.63336 1.50015Z" stroke="#006EFA" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
																						</g>
																						<defs>
																							<clipPath id="clip0_568_443">
																								<rect width="12" height="12" fill="white" transform="translate(0.133362)" />
																							</clipPath>
																						</defs>
																					</svg>
																				</span>
																				Edit
																			</button>
																		)}
																	</div>
																</div>
																<div class="row">
																	<div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
																		<div class="single-box">
																			<div class="icon-box">
																				{/* icon and colour change */}
																				<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 25 24" fill="none">
																					<path d="M20.6 21V19C20.6 17.9391 20.1785 16.9217 19.4284 16.1716C18.6783 15.4214 17.6608 15 16.6 15H8.59998C7.53911 15 6.52169 15.4214 5.77155 16.1716C5.0214 16.9217 4.59998 17.9391 4.59998 19V21" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
																					<path d="M12.6 11C14.8091 11 16.6 9.20914 16.6 7C16.6 4.79086 14.8091 3 12.6 3C10.3908 3 8.59998 4.79086 8.59998 7C8.59998 9.20914 10.3908 11 12.6 11Z" fill="#006EFA" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
																				</svg>
																			</div>
																			<div class="only-text">
																				<div class="top-text">
																					Account Manager
																				</div>
																				<div class="bottom-text">
																					{this.state.data &&
																						this.state.data.account_manager
																						? this.state.asyncApiData
																							.account_manager &&
																							this.state.asyncApiData.account_manager.find(
																								(item) =>
																									item.value ===
																									this.state.data
																										.account_manager
																							)
																							? this.state.asyncApiData.account_manager.find(
																								(item) =>
																									item.value ===
																									this.state.data
																										.account_manager
																							).label
																							: "-NA-"
																						: "-NA-"}{" "}
																				</div>
																			</div>
																		</div>
																	</div>
																	<div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
																		<div class="single-box">
																			<div class="icon-box">
																				{/* icon and colour change */}
																				<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 25 24" fill="none">
																					<path d="M20.6 21V19C20.6 17.9391 20.1785 16.9217 19.4284 16.1716C18.6783 15.4214 17.6608 15 16.6 15H8.59998C7.53911 15 6.52169 15.4214 5.77155 16.1716C5.0214 16.9217 4.59998 17.9391 4.59998 19V21" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
																					<path d="M12.6 11C14.8091 11 16.6 9.20914 16.6 7C16.6 4.79086 14.8091 3 12.6 3C10.3908 3 8.59998 4.79086 8.59998 7C8.59998 9.20914 10.3908 11 12.6 11Z" fill="#006EFA" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
																				</svg>
																			</div>
																			<div class="only-text">
																				<div class="top-text">TSE Owner</div>
																				<div class="bottom-text">
																					{this.state.data &&
																						this.state.data.tse_owner
																						? this.state.asyncApiData
																							.tse_owner &&
																							this.state.asyncApiData.tse_owner.find(
																								(item) =>
																									item.value ===
																									this.state.data
																										.tse_owner
																							)
																							? this.state.asyncApiData.tse_owner.find(
																								(item) =>
																									item.value ===
																									this.state.data
																										.tse_owner
																							).label
																							: "-NA-"
																						: "-NA-"}{" "}
																				</div>
																			</div>
																		</div>
																	</div>
																	<div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
																		<div class="single-box">
																			<div class="icon-box">
																				{/* icon and colour change */}
																				<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 25 24" fill="none">
																					<path d="M20.6 21V19C20.6 17.9391 20.1785 16.9217 19.4284 16.1716C18.6783 15.4214 17.6608 15 16.6 15H8.59998C7.53911 15 6.52169 15.4214 5.77155 16.1716C5.0214 16.9217 4.59998 17.9391 4.59998 19V21" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
																					<path d="M12.6 11C14.8091 11 16.6 9.20914 16.6 7C16.6 4.79086 14.8091 3 12.6 3C10.3908 3 8.59998 4.79086 8.59998 7C8.59998 9.20914 10.3908 11 12.6 11Z" fill="#006EFA" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
																				</svg>
																			</div>
																			<div class="only-text">
																				<div class="top-text">
																					Sales Manager
																				</div>
																				<div class="bottom-text">
																					{this.state.data &&
																						this.state.data.sales_manager
																						? this.state.asyncApiData
																							.sales_manager &&
																							this.state.asyncApiData.sales_manager.find(
																								(item) =>
																									item.value ===
																									this.state.data
																										.sales_manager
																							)
																							? this.state.asyncApiData.sales_manager.find(
																								(item) =>
																									item.value ===
																									this.state.data
																										.sales_manager
																							).label
																							: "-NA-"
																						: "-NA-"}{" "}
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
														<div class="product-tab chat">
															{/* <div class="row">
                                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                  <ul class="nav nav-tabs" role="tablist">
                                    {this.state.products &&
                                      this.state.products.map((data, key) => (
                                        <li
                                          role="presentation"
                                          className={key === 0 ? "active" : ""}
                                          key={key}
                                        >
                                          <a
                                            href="#one"
                                            aria-controls="one"
                                            role="tab"
                                            data-toggle="tab"
                                            aria-expanded="true"
                                            onClick={() =>
                                              this.handleTabClick(data)
                                            }
                                          >
                                            {data.product_name
                                              ? data.product_name
                                              : "NA"}
                                          </a>
                                        </li>
                                      ))}
                                  </ul>
                                </div>
                              </div> */}
															<div role="tabpanel" class="tab-pane" id="one">
																{this.state.isLoadingApiCalling ? (
																	<div className="loader-new"></div>
																) : (
																	<div class="row">
																		<div class="col-xs-12 product-section">
																			<div class="title">Product</div>
																			<div class="ana-account">
																				<div class="">
																					<div class="single-box">
																						<div class="only-text">
																							<div class="top-text">
																								Customer Type
																							</div>
																							<div class="bottom-text">
																								{this.state.data
																									.customer_type
																									? this.state.data
																										.customer_type
																									: "NA"}
																							</div>
																						</div>
																					</div>
																				</div>
																				<div class="">
																					<div class="single-box">
																						<div class="only-text">
																							<div class="top-text">
																								Product
																							</div>
																							<div class="bottom-text">
																								Muvi One (Classic)
																							</div>
																						</div>
																					</div>
																				</div>
																				<div class="">
																					<div class="single-box">
																						<div class="only-text">
																							<div class="top-text">
																								Joined On
																							</div>
																							<div class="bottom-text">
																								{this.state.data
																									.created_at
																									? new Date(
																										this.state.data.created_at
																									).toLocaleDateString(
																										"en-US",
																										{
																											month: "short",
																											day: "numeric",
																											year: "numeric",
																										}
																									)
																									: "NA"}
																							</div>
																						</div>
																					</div>
																				</div>
																				<div class="">
																					<div class="single-box">
																						<div class="only-text">
																							<div class="top-text">
																								Product Plan
																							</div>
																							<div class="bottom-text cap-text">
																								{this.state.data.package
																									? this.state.data
																										.package
																										.name
																									: "NA"}
																							</div>
																						</div>
																					</div>
																				</div>
																				<div class="">
																					<div class="single-box">
																						<div class="only-text">
																							<div class="top-text">
																								Product Pricing
																							</div>
																							<div class="bottom-text">
																								{this.state.data
																									.package ? (
																									this.state.data
																										.package.name ==
																										"Muvi Standard" ? (
																										<div class="bottom-text">
																											{this.state
																												.data
																												.package
																												? this
																													.state
																													.data
																													.is_old &&
																													this
																														.state
																														.data
																														.package
																														.is_old_base_price
																													? "$ " +
																													this
																														.state
																														.data
																														.base_price
																													: "$ " +
																													this
																														.state
																														.data
																														.package
																														.base_price
																												: "NA"}
																										</div>
																									) : (
																										<div class="bottom-text">
																											{this.state
																												.data
																												.package
																												? this
																													.state
																													.data
																													.is_old !=
																													"0" &&
																													this
																														.state
																														.data
																														.is_old !=
																													0 &&
																													this
																														.state
																														.data
																														.package
																														.is_old_base_price !=
																													"0" &&
																													this
																														.state
																														.data
																														.package
																														.is_old_base_price !=
																													0
																													? "$ " +
																													this
																														.state
																														.data
																														.base_price
																													: "$ " +
																													this
																														.state
																														.data
																														.package
																														.base_price
																												: "NA"}
																										</div>
																									)
																								) : (
																									<div class="bottom-text">
																										NA
																									</div>
																								)}
																							</div>
																						</div>
																					</div>
																				</div>
																				<div class="">
																					<div class="single-box">
																						<div class="only-text">
																							<div class="top-text">
																								Plan Term
																							</div>
																							<div class="bottom-text">
																								{" "}
																								{this.state.data
																									.sel_plan
																									? this.state.data
																										.sel_plan
																									: "NA"}
																							</div>
																						</div>
																					</div>
																				</div>
																				<div class="">
																					<div class="single-box">
																						<div class="only-text">
																							<div class="top-text">
																								Source
																							</div>
																							<div class="bottom-text">
																								{" "}
																								{this.state.data
																									.source ? (
																									<Link
																										to={`${this.state.data.source.startsWith(
																											"http://"
																										) ||
																											this.state.data.source.startsWith(
																												"https://"
																											)
																											? this
																												.state
																												.data
																												.source
																											: `https://${this.state.data.source}`
																											}`}
																										name={"max"}
																										target="_blank"
																									>
																										{" "}
																										{
																											this.state
																												.data
																												.source
																										}{" "}
																									</Link>
																								) : (
																									"NA"
																								)}
																							</div>
																						</div>
																					</div>
																				</div>
																				<div class="">
																					<div class="single-box">
																						<div class="only-text">
																							<div class="top-text">
																								Applications
																							</div>
																							<div class="bottom-text">
																								{this.state.applications
																									.length > 0
																									? this.state.applications.map(
																										(
																											data,
																											key
																										) => (
																											<span>
																												{" "}
																												{
																													data.name
																												}
																												{key !==
																													this
																														.state
																														.applications
																														.length -
																													1
																													? ", "
																													: ""}
																											</span>
																										)
																									)
																									: "NA"}
																							</div>
																						</div>
																					</div>
																				</div>
																				<div class="">
																					<div class="single-box">
																						<div class="only-text">
																							<div class="top-text">
																								Free Trial Expires On
																							</div>
																							<div class="bottom-text">
																								NA
																							</div>
																						</div>
																					</div>
																				</div>
																				<div class="">
																					<div class="single-box">
																						<div class="only-text">
																							<div class="top-text">
																								Template
																							</div>
																							<div class="bottom-text">
																								NA
																							</div>
																						</div>
																					</div>
																				</div>
																			</div>
																		</div>
																		<div class="col-xs-12">
																			<div class="title">Analytics</div>
																			<div className="analitcs">
																				<div class="">
																					<div class="single-box">
																						<div class="icon-box">
																							{/* icon and colour change */}
																							<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
																								<g clip-path="url(#clip0_568_322)">
																									<path d="M14.44 10.5934C14.0159 11.5964 13.3525 12.4802 12.5079 13.1676C11.6633 13.855 10.6632 14.325 9.59495 14.5366C8.52673 14.7481 7.42294 14.6948 6.38009 14.3813C5.33724 14.0677 4.38708 13.5034 3.61267 12.7378C2.83827 11.9722 2.2632 11.0286 1.93775 9.98935C1.6123 8.95015 1.54637 7.84704 1.74572 6.77647C1.94508 5.70591 2.40366 4.70047 3.08136 3.84807C3.75906 2.99567 4.63525 2.32226 5.63333 1.88672" stroke="#006EFA" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
																									<path d="M14.9667 8.00016C14.9667 7.12468 14.7942 6.25778 14.4592 5.44894C14.1242 4.6401 13.6331 3.90517 13.014 3.28612C12.395 2.66706 11.66 2.176 10.8512 1.84097C10.0424 1.50593 9.17547 1.3335 8.29999 1.3335V8.00016H14.9667Z" fill="#006EFA" stroke="#006EFA" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
																								</g>
																								<defs>
																									<clipPath id="clip0_568_322">
																										<rect width="16" height="16" fill="white" transform="translate(0.299988)" />
																									</clipPath>
																								</defs>
																							</svg>
																						</div>
																						<div class="only-text">
																							<div class="top-text">
																								Storage
																							</div>
																							<div class="bottom-text">
																								{" "}
																								{this.state.storage
																									? this.state.storage
																									: "0"}
																							</div>
																						</div>
																					</div>
																				</div>
																				<div class="">
																					<div class="single-box">
																						<div class="icon-box">
																							{/* icon and colour change */}
																							<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
																								<g clip-path="url(#clip0_568_366)">
																									<path d="M8.62567 13.8695C8.71798 14.4112 8.91029 14.9153 9.17952 15.3743H3.17182C2.31798 15.3743 1.63336 14.7047 1.63336 13.8695V1.83142C1.63336 1.43233 1.79545 1.04959 2.08397 0.767395C2.37248 0.485197 2.7638 0.32666 3.17182 0.32666H9.32567L13.9411 4.84095V8.67057C13.6872 8.63295 13.4334 8.60285 13.1718 8.60285C12.9103 8.60285 12.6564 8.63295 12.4026 8.67057V5.59333H8.55644V1.83142H3.17182V13.8695H8.62567ZM11.6334 10.1076L9.71029 12.3648H10.8641V15.3743H12.4026V12.3648H13.5564L11.6334 10.1076ZM15.4795 13.8695V10.86H13.9411V13.8695H12.7872L14.7103 16.1267L16.6334 13.8695H15.4795Z" fill="#006EFA" />
																								</g>
																								<defs>
																									<clipPath id="clip0_568_366">
																										<rect width="16" height="16" fill="white" transform="translate(0.633301)" />
																									</clipPath>
																								</defs>
																							</svg>
																						</div>
																						<div class="only-text">
																							<div class="top-text">
																								Total Content Uploaded
																							</div>
																							<div class="bottom-text">
																								{this.state.count
																									? this.state.count
																									: "0"}
																							</div>
																						</div>
																					</div>
																				</div>

																				<div class="">
																					<div class="single-box">
																						<div class="icon-box">
																							{/* icon and colour change */}
																							<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
																								<g clip-path="url(#clip0_568_330)">
																									<mask id="mask0_568_330" maskUnits="userSpaceOnUse" x="0" y="1" width="17" height="14">
																										<path d="M8.6633 2C4.78063 2 1.6333 5.14733 1.6333 9.03C1.6333 10.8683 2.23542 12.6983 3.3908 13.951H13.9358C15.0908 12.6983 15.6933 10.8683 15.6933 9.03C15.6933 5.14733 12.546 2 8.6633 2Z" stroke="white" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
																										<path d="M8.66332 11.4907C9.43984 11.4907 10.0693 10.8612 10.0693 10.0847C10.0693 9.3082 9.43984 8.67871 8.66332 8.67871C7.88681 8.67871 7.25732 9.3082 7.25732 10.0847C7.25732 10.8612 7.88681 11.4907 8.66332 11.4907Z" fill="white" stroke="white" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
																										<path d="M8.66337 6.56932V8.67832M8.66337 3.75732V4.46032M3.39087 9.38132H4.09387M4.79687 5.86632L5.29389 6.36334M13.2329 9.38132H13.9359M12.1784 6.36334L12.6754 5.86632" stroke="white" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
																									</mask>
																									<g mask="url(#mask0_568_330)">
																										<path d="M-0.0462036 -0.460449H17.1773V16.4116H-0.0462036V-0.460449Z" fill="#006EFA" />
																									</g>
																								</g>
																								<defs>
																									<clipPath id="clip0_568_330">
																										<rect width="16" height="15.6735" fill="white" transform="translate(0.633301)" />
																									</clipPath>
																								</defs>
																							</svg>
																						</div>
																						<div class="only-text">
																							<div class="top-text">
																								Bandwidth Used This
																								Month
																							</div>
																							<div class="bottom-text">
																								{" "}
																								{this.state
																									.get_bandwidth_api ==
																									1
																									? this.state
																										.bandwidth
																									: "0"}
																							</div>
																						</div>
																					</div>
																				</div>
																				<div class="">
																					<div class="single-box">
																						<div class="icon-box">
																							{/* icon and colour change */}
																							<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
																								<path d="M10.9667 2H13.6333C13.987 2 14.3261 2.14048 14.5762 2.39052C14.8262 2.64057 14.9667 2.97971 14.9667 3.33333V12.6667C14.9667 13.0203 14.8262 13.3594 14.5762 13.6095C14.3261 13.8595 13.987 14 13.6333 14H10.9667" stroke="#006EFA" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
																								<path d="M7.63333 11.3332L10.9667 7.99984L7.63333 4.6665" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
																								<path d="M10.9667 8H2.96667" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
																							</svg>
																						</div>
																						<div class="only-text">
																							<div class="top-text">
																								Count of Login
																							</div>
																							<div class="bottom-text">
																								{" "}
																								{this.state.data
																									.total_login
																									? this.state.data
																										.total_login
																									: "0"}
																							</div>
																						</div>
																					</div>
																				</div>
																				<div class="">
																					<div class="single-box">
																						<div class="icon-box">
																							{/* icon and colour change */}
																							<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
																								<path d="M10.9667 2H13.6333C13.987 2 14.3261 2.14048 14.5762 2.39052C14.8262 2.64057 14.9667 2.97971 14.9667 3.33333V12.6667C14.9667 13.0203 14.8262 13.3594 14.5762 13.6095C14.3261 13.8595 13.987 14 13.6333 14H10.9667" stroke="#006EFA" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
																								<path d="M7.63333 11.3332L10.9667 7.99984L7.63333 4.6665" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
																								<path d="M10.9667 8H2.96667" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
																							</svg>
																						</div>
																						<div class="only-text">
																							<div class="top-text">
																								Number of EndUsers
																							</div>
																							<div class="bottom-text">
																								{" "}
																								{this.state
																									.enduser_count
																									? this.state
																										.enduser_count
																									: "0"}
																							</div>
																						</div>
																					</div>
																				</div>
																				<div class="">
																					<div class="single-box">
																						<div class="icon-box">
																							{/* icon and colour change */}
																							<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
																								<g clip-path="url(#clip0_568_373)">
																									<path d="M12.3 14V12.6667C12.3 11.9594 12.019 11.2811 11.5189 10.781C11.0189 10.281 10.3406 10 9.63333 10H4.3C3.59275 10 2.91448 10.281 2.41438 10.781C1.91428 11.2811 1.63333 11.9594 1.63333 12.6667V14" stroke="#006EFA" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
																									<path d="M6.96668 7.33333C8.43944 7.33333 9.63335 6.13943 9.63335 4.66667C9.63335 3.19391 8.43944 2 6.96668 2C5.49393 2 4.30002 3.19391 4.30002 4.66667C4.30002 6.13943 5.49393 7.33333 6.96668 7.33333Z" fill="#006EFA" stroke="#006EFA" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
																									<path d="M16.3 13.9998V12.6664C16.2996 12.0756 16.1029 11.5016 15.7409 11.0346C15.3789 10.5677 14.8721 10.2341 14.3 10.0864" stroke="#006EFA" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
																									<path d="M11.6333 2.08643C12.2069 2.23329 12.7154 2.56689 13.0784 3.03463C13.4415 3.50237 13.6386 4.07765 13.6386 4.66976C13.6386 5.26187 13.4415 5.83715 13.0784 6.30489C12.7154 6.77262 12.2069 7.10623 11.6333 7.25309" stroke="#006EFA" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
																								</g>
																								<defs>
																									<clipPath id="clip0_568_373">
																										<rect width="16" height="16" fill="white" transform="translate(0.966675)" />
																									</clipPath>
																								</defs>
																							</svg>
																						</div>
																						<div class="only-text">
																							<div class="top-text">
																								Number of Subscribers
																							</div>
																							<div class="bottom-text">
																								{" "}
																								{
																									this.state
																										.total_no_of_subscribed_users
																								}
																							</div>
																						</div>
																					</div>
																				</div>
																				<div class="">
																					<div class="single-box">
																						<div class="icon-box">
																							{/* icon and colour change */}
																							<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
																								<path d="M10.9667 2H13.6333C13.987 2 14.3261 2.14048 14.5762 2.39052C14.8262 2.64057 14.9667 2.97971 14.9667 3.33333V12.6667C14.9667 13.0203 14.8262 13.3594 14.5762 13.6095C14.3261 13.8595 13.987 14 13.6333 14H10.9667" stroke="#006EFA" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
																								<path d="M7.63333 11.3332L10.9667 7.99984L7.63333 4.6665" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
																								<path d="M10.9667 8H2.96667" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
																							</svg>
																						</div>
																						<div class="only-text">
																							<div class="top-text">
																								Number of SubAdmin
																							</div>
																							<div class="bottom-text">
																								{" "}
																								{this.state
																									.subadmin_count
																									? this.state
																										.subadmin_count
																									: "0"}
																							</div>
																						</div>
																					</div>
																				</div>
																				<div class="">
																					<div class="single-box">
																						<div class="icon-box">
																							{/* icon and colour change */}
																							<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
																								<g clip-path="url(#clip0_568_384)">
																									<path d="M15.6734 13.4074H15.1302V2.54321C15.1302 2.39914 15.073 2.26097 14.9711 2.1591C14.8693 2.05723 14.7311 2 14.587 2H10.7846C10.6405 2 10.5023 2.05723 10.4004 2.1591C10.2986 2.26097 10.2413 2.39914 10.2413 2.54321V5.25926H6.98209C6.83802 5.25926 6.69985 5.31649 6.59798 5.41836C6.49611 5.52023 6.43888 5.6584 6.43888 5.80247V8.51852H3.17962C3.03555 8.51852 2.89738 8.57575 2.79551 8.67762C2.69364 8.77949 2.63641 8.91766 2.63641 9.06173V13.4074H2.0932C1.94913 13.4074 1.81096 13.4646 1.70909 13.5665C1.60722 13.6684 1.54999 13.8066 1.54999 13.9506C1.54999 14.0947 1.60722 14.2329 1.70909 14.3347C1.81096 14.4366 1.94913 14.4938 2.0932 14.4938H15.6734C15.8175 14.4938 15.9557 14.4366 16.0576 14.3347C16.1594 14.2329 16.2167 14.0947 16.2167 13.9506C16.2167 13.8066 16.1594 13.6684 16.0576 13.5665C15.9557 13.4646 15.8175 13.4074 15.6734 13.4074ZM7.5253 6.34568H10.2413V13.4074H7.5253V6.34568ZM3.72283 9.60494H6.43888V13.4074H3.72283V9.60494Z" fill="#006EFA" />
																								</g>
																								<defs>
																									<clipPath id="clip0_568_384">
																										<rect width="16" height="16" fill="white" transform="translate(0.299988)" />
																									</clipPath>
																								</defs>
																							</svg>
																						</div>
																						<div class="only-text">
																							<div class="top-text">
																								Customer Revenue
																							</div>
																							<div class="bottom-text">
																								{" "}
																								{this.state.currency &&
																									this.state.currency
																										.length > 0
																									? this.getRevenue()
																									: "0"}
																							</div>
																						</div>
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>
																)}
															</div>
														</div>
														<div class="bottom-area">
															<div className="row">
																<div class="col-md-12">
																	<div class="product-area revenue-area">
																		<div class="store-title">
																			Revenue &amp; Billing
																		</div>
																		<div>
																			<div class="row">
																				<div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
																					<div class="single-product">
																						<div class="top-text">
																							Last Paid Amount
																						</div>
																						<div class="bottom-text">
																							{" "}
																							{this.state.data.paid_amount
																								? "$ " +
																								this.state.data
																									.paid_amount
																								: "NA"}
																						</div>
																					</div>
																				</div>
																				<div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
																					<div class="single-product">
																						<div class="top-text">
																							Mode of payment
																						</div>
																						<div class="bottom-text">
																							{" "}
																							{this.state.payment_method
																								? this.state
																									.payment_method
																								: "NA"}
																						</div>
																					</div>
																				</div>
																				<div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
																					<div class="single-product">
																						<div class="top-text">
																							Subscription Started On
																						</div>
																						<div class="bottom-text">
																							{" "}
																							{this.state.data
																								.subscription_start
																								? new Date(
																									this.state.data.subscription_start
																								).toLocaleDateString(
																									"en-US",
																									{
																										month: "short",
																										day: "numeric",
																										year: "numeric",
																									}
																								)
																								: "NA"}
																						</div>
																					</div>
																				</div>
																				<div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
																					<div class="single-product">
																						<div class="top-text">
																							Revenue Last 30Days
																						</div>
																						<div class="bottom-text">
																							{this.state
																								.revenue_last_month
																								? "$ " +
																								this.state
																									.revenue_last_month
																								: "NA"}
																						</div>
																					</div>
																				</div>
																				<div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
																					<div class="single-product">
																						<div class="top-text">
																							Revenue Lifetime
																						</div>
																						<div class="bottom-text">
																							{this.state
																								.revenue_lifetime ||
																								this.state
																									.revenue_lifetime == 0
																								? "$" +
																								this.state
																									.revenue_lifetime
																								: "$0"}
																						</div>
																					</div>
																				</div>
																				<div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
																					<div class="single-product">
																						<div class="top-text">
																							Last Transaction Date
																						</div>
																						<div class="bottom-text">
																							{" "}
																							{this.state.data
																								.created_date &&
																								this.state.data
																									.created_date != "" &&
																								this.state.data
																									.created_date !=
																								"00-00-00 00:00:00"
																								? new Date(
																									this.state.data.created_date
																								).toLocaleDateString(
																									"en-US",
																									{
																										month: "short",
																										day: "numeric",
																										year: "numeric",
																									}
																								)
																								: "NA"}
																						</div>
																					</div>
																				</div>
																				<div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
																					<div class="single-product">
																						<div class="top-text">
																							Next Subscription Billing
																							Date
																						</div>
																						<div class="bottom-text">
																							{" "}
																							{this.state.data
																								.start_date &&
																								this.state.data
																									.start_date != "" &&
																								this.state.data
																									.start_date !=
																								"00-00-00 00:00:00"
																								? new Date(
																									this.state.data.start_date
																								).toLocaleDateString(
																									"en-US",
																									{
																										month: "short",
																										day: "numeric",
																										year: "numeric",
																									}
																								)
																								: this.state.data
																									.end_date &&
																									this.state.data
																										.end_date !=
																									"" &&
																									this.state.data
																										.end_date !=
																									"00-00-00 00:00:00"
																									? new Date(
																										this.state.data.end_date
																									).toLocaleDateString(
																										"en-US",
																										{
																											month: "short",
																											day: "numeric",
																											year: "numeric",
																										}
																									)
																									: "N/A"}
																						</div>
																					</div>
																				</div>
																				<div class="col-lg-4 col-md-4 col-sm-4 col-xs-6">
																					<div class="single-product">
																						<div class="top-text">
																							Next Infra Billing Date
																						</div>
																						<div class="bottom-text">
																							{this.state
																								.next_infra_billing_date
																								? new Date(
																									this.state.next_infra_billing_date
																								).toLocaleDateString(
																									"en-US",
																									{
																										month: "short",
																										day: "numeric",
																										year: "numeric",
																									}
																								)
																								: "NA"}
																						</div>
																					</div>
																				</div>
																				<div>
																					{" "}
																					{this.getcardDetails()}
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
																<div class="col-md-12">
																	<div class="product-area account-area">
																		<div class="store-title">Account</div>
																		<div>
																			<div class="row">
																				<div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
																					<div class="single-product">
																						<div class="top-text">
																							Cancelled By
																						</div>
																						<div class="bottom-text">
																							{" "}
																							{this.state.data
																								.cancelled_by
																								? this.state.data
																									.cancelled_by
																								: "NA"}
																						</div>
																					</div>
																				</div>
																				<div class="col-lg-8 col-md-6 col-sm-6 col-xs-12">
																					<div class="single-product">
																						<div class="top-text">
																							Cancellation Reason
																						</div>
																						<div class="bottom-text">
																							{this.state.data.reason
																								? this.state.data.reason
																								: "NA"}
																						</div>
																					</div>
																				</div>
																			</div>
																			<div className="row">
																				<div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
																					<div class="single-product">
																						<div class="top-text">
																							Cancellation Date
																						</div>
																						<div class="bottom-text">
																							{this.state.data
																								.start_date_change &&
																								this.state.data
																									.start_date_change !=
																								"" &&
																								this.state.data
																									.start_date_change !=
																								"00-00-00 00:00:00"
																								? new Date(
																									this.state.data.start_date_change
																								).toLocaleDateString(
																									"en-US",
																									{
																										month: "short",
																										day: "numeric",
																										year: "numeric",
																									}
																								)
																								: "NA"}{" "}
																						</div>
																					</div>
																				</div>
																				<div class="col-lg-8 col-md-6 col-sm-6 col-xs-12">
																					<div class="single-product">
																						<div class="top-text">
																							On hold Period
																						</div>
																						<div class="bottom-text">
																							{this.state.data
																								.start_date_change
																								? new Date(
																									this.state.data.start_date_change
																								).toLocaleDateString(
																									"en-US",
																									{
																										month: "short",
																										day: "numeric",
																										year: "numeric",
																									}
																								) +
																								" - " +
																								new Date(
																									this.state.data.end_date_change
																								).toLocaleDateString(
																									"en-US",
																									{
																										month: "short",
																										day: "numeric",
																										year: "numeric",
																									}
																								)
																								: "NA"}
																						</div>
																					</div>
																				</div>
																			</div>
																			<div className="row">
																				<div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
																					<div class="single-product">
																						<div class="top-text">
																							Deleted by
																						</div>
																						<div class="bottom-text">
																							NA
																						</div>
																					</div>
																				</div>
																				<div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
																					<div class="single-product">
																						<div class="top-text">
																							Deletion Date
																						</div>
																						<div class="bottom-text">
																							{" "}
																							{this.state.data
																								.deleted_date
																								? new Date(
																									this.state.data.deleted_date
																								).toLocaleDateString(
																									"en-US",
																									{
																										month: "short",
																										day: "numeric",
																										year: "numeric",
																									}
																								)
																								: "NA"}
																						</div>
																					</div>
																				</div>
																			</div>
																			<div className="row">
																				<div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
																					<div class="single-product">
																						<div class="top-text">
																							Blocked
																						</div>
																						<div class="bottom-text">
																							{" "}
																							{this.state.data
																								.is_blocked == 1
																								? "Yes"
																								: "No"}
																						</div>
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
															{/* {this.productStore("revenueandbilling")} */}
														</div>
													</div>
													<div class="col-md-6">
														<div class="full-chat-area">
															<div class="chat-middle">
																<ul class="nav nav-tabs" role="tablist" id="myTab">
																	{/* <li>
                                    <a
                                      href="#notes"
                                      role="tab"
                                      data-toggle="tab"
                                      aria-expanded="false"
                                    >
                                      notes
                                    </a>
                                  </li> */}
																	<li class="active">
																		<a
																			href="#notes"
																			role="tab"
																			data-toggle="tab"
																			aria-expanded="true"
																		>
																			Notes
																		</a>
																	</li>
																</ul>
																<div class="tab-content">
																	<div class="tab-pane active" id="notes">
																		<div class="note-viewarea">
																			{this.state.noteError ? (
																				<label className="note-error-msg">
																					Please fill the field *
																				</label>
																			) : (
																				""
																			)}

																			<div class="check-wrap">
																				{this.state.userType == "internal" ? (
																					<div class="input-groups">
																						<span class="input-group-addons">
																							<input
																								type="radio"
																								name="clouds"
																								id="Clear"
																								value="internal"
																								onChange={this.onChange}
																								checked
																							/>
																						</span>
																						<label for="">Internal</label>
																					</div>
																				) : (
																					<div class="input-groups">
																						<span class="input-group-addons">
																							<input
																								type="radio"
																								name="clouds"
																								id="Clear"
																								value="internal"
																								onChange={this.onChange}
																							/>
																						</span>
																						<label for="">Internal</label>
																					</div>
																				)}
																				{this.state.userType == "external" ? (
																					<div class="input-groups">
																						<span class="input-group-addons">
																							<input
																								type="radio"
																								name="clouds"
																								id="Cloudy"
																								value="external"
																								onChange={this.onChange}
																								checked
																							/>
																						</span>
																						<label for="">Customer</label>
																					</div>
																				) : (
																					<div class="input-groups">
																						<span class="input-group-addons">
																							<input
																								type="radio"
																								name="clouds"
																								id="Cloudy"
																								value="external"
																								onChange={this.onChange}
																							/>
																						</span>
																						<label for="">Customer</label>
																					</div>
																				)}
																			</div>
																			<form class="form-area">
																				{Object.keys(this.state.userList)
																					.length > 0 && (
																						<EditorNew
																							getEditorData={this.addChatNote}
																							noteAdd={this.noteAdd}
																							show_toolbar={true}
																							field_name="chat_note"
																							edit_id={this.state.editId}
																							noteAdding={
																								this.state.noteAdding
																							}
																							// users={
																							// 	this.state.userList || {}
																							// }
																							users={activeUserList}
																						/>
																					)}
																			</form>
																			<div class="note-content-area">
																				{this.state.crmNotes.data &&
																					this.state.crmNotes.data.map(
																						(item) => {
																							return (
																								<div
																									class={`single-content ${item.note_type ===
																										"external" ||
																										item.note_type ===
																										"customer"
																										? "customer"
																										: "internal"
																										}`}
																								>
																									<div class="img-box">
																										<img
																											src={
																												this
																													.state
																													.userList[
																												item
																													.user_uuid
																												] &&
																												this
																													.state
																													.userList[
																													item
																														.user_uuid
																												]
																													.profile_pic
																											}
																										/>
																									</div>
																									<div class="item-area">
																										<div class="title-area">
																											<h5>
																												<a href="#">
																													{this
																														.state
																														.userList[
																														item
																															.user_uuid
																													] &&
																														this
																															.state
																															.userList[
																															item
																																.user_uuid
																														]
																															.name}{" "}
																												</a>
																											</h5>
																											{item.note_type ==
																												"external" ? (
																												<div class="bagde-customer">
																													Customer
																												</div>
																											) : (
																												<div class="bagde-internal">
																													Internal
																												</div>
																											)}
																											{/* 
                                                      <div
                                                        class="editNote"
                                                        data-toggle="modal"
                                                        data-target="#edit-note"
                                                      >
                                                        <svg
                                                          width="14"
                                                          height="15"
                                                          viewBox="0 0 14 15"
                                                          fill="none"
                                                          xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                          <path
                                                            d="M10.7974 1.36955C10.9725 1.19445 11.1803 1.05556 11.4091 0.960795C11.6379 0.866034 11.8831 0.817261 12.1307 0.817261C12.3783 0.817261 12.6235 0.866034 12.8523 0.960795C13.0811 1.05556 13.2889 1.19445 13.464 1.36955C13.6391 1.54464 13.778 1.75251 13.8728 1.98128C13.9675 2.21006 14.0163 2.45526 14.0163 2.70288C14.0163 2.9505 13.9675 3.1957 13.8728 3.42447C13.778 3.65325 13.6391 3.86112 13.464 4.03621L4.46403 13.0362L0.797363 14.0362L1.79736 10.3695L10.7974 1.36955Z"
                                                            stroke="#666666"
                                                            stroke-width="1.33"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                          ></path>
                                                        </svg>
                                                      </div> */}
																										</div>
																										<div class="snote">
																											{moment(
																												unix(
																													item.created_timestamp
																												)
																											).format(
																												"MMMM D, YYYY"
																											)}
																										</div>
																										<div class="text-area">
																											{item.highlight_text ? (
																												<blockquote
																													class="quote-card"
																													dangerouslySetInnerHTML={{
																														__html: item.highlight_text,
																													}}
																												></blockquote>
																											) : (
																												""
																											)}
																											<div
																												dangerouslySetInnerHTML={{
																													__html: item.note_content,
																												}}
																											></div>
																										</div>
																									</div>
																								</div>
																							);
																						}
																					)}
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div role="tabpanel" class="tab-pane app-info-data" id="app">
												<div class="row">
													<div class="col-md-6">
														<div class="app-box">
															<div class="row">
																<div className="col-md-8">
																	{" "}
																	<div class="col-md-12">
																		<div class="app-info">
																			<span>API Key</span>
																			{this.state.apiKey ? (
																				<p>{this.state.apiKey}</p>
																			) : (
																				<p>NA</p>
																			)}
																		</div>
																	</div>
																	<div class="col-md-4">
																		<div class="app-info">
																			<span>SDK Name</span>
																			{this.state.package_name ? (
																				this.state.package_name
																			) : (
																				<p>NA</p>
																			)}{" "}
																		</div>
																	</div>
																	<div class="col-md-4">
																		<div class="app-info">
																			<span>S3 Location</span>
																			{this.state.data.region_name ? (
																				<p>{this.state.data.region_name}</p>
																			) : (
																				"NA"
																			)}
																		</div>
																	</div>
																	<div class="col-md-4">
																		<div class="app-info">
																			{this.state.data.package ? (
																				this.state.data.package.name ==
																					"Muvi Standard" ? (
																					<div></div>
																				) : (
																					<div class="filter customer_filter">
																						<select
																							class="form-control customer_form-control"
																							style={{
																								padding:
																									"0px 23px 0px 9px",
																								fontSize: "12px",
																								height: "23px",
																							}}
																						>
																							<option value="All_levels">
																								Singapore
																							</option>
																							<option value="saab">
																								Saab
																							</option>
																							<option value="mercedes">
																								Mercedes
																							</option>
																							<option value="audi">
																								Audi
																							</option>
																						</select>
																						<i
																							class="fa fa-angle-down s3-i"
																							aria-hidden="true"
																							style={{
																								fontSize: "14px",
																								marginTop: "-18px",
																							}}
																						>
																							{" "}
																						</i>
																					</div>
																				)
																			) : (
																				<p>NA</p>
																			)}
																		</div>
																	</div>
																</div>
																<div className="col-md-4">
																	{" "}
																	<div className="d-flex flex-column">
																		<button
																			class="editprimary-btn"
																			id="sdk_change"
																			onClick={this.toggle1.bind(this)}
																		>
																			<span>
																				<svg
																					xmlns="http://www.w3.org/2000/svg"
																					width="12"
																					height="12"
																					viewBox="0 0 12 12"
																					fill="none"
																				>
																					<g clip-path="url(#clip0_501_8376)">
																						<path
																							d="M8.5 1.5C8.63132 1.36868 8.78722 1.26451 8.9588 1.19344C9.13038 1.12236 9.31428 1.08578 9.5 1.08578C9.68572 1.08578 9.86962 1.12236 10.0412 1.19344C10.2128 1.26451 10.3687 1.36868 10.5 1.5C10.6313 1.63132 10.7355 1.78722 10.8066 1.9588C10.8776 2.13038 10.9142 2.31428 10.9142 2.5C10.9142 2.68572 10.8776 2.86961 10.8066 3.04119C10.7355 3.21277 10.6313 3.36868 10.5 3.5L3.75 10.25L1 11L1.75 8.25L8.5 1.5Z"
																							stroke="#006EFA"
																							stroke-width="1.33"
																							stroke-linecap="round"
																							stroke-linejoin="round"
																						></path>
																					</g>
																					<defs>
																						<clipPath id="clip0_501_8376">
																							<rect
																								width="12"
																								height="12"
																								fill="white"
																							></rect>
																						</clipPath>
																					</defs>
																				</svg>
																			</span>
																			Change
																		</button>
																		<span
																			id="sdk_span_txt"
																			style={{ display: "none" }}
																		>
																			<input
																				style={{ width: "100%" }}
																				type="text"
																				id="sdk_name_txt"
																				name="sdk_name"
																				value={this.state.package_name}
																				onChange={this.onChangePackage.bind(
																					this,
																					"package_name"
																				)}
																			/>
																			<input
																				type="hidden"
																				id="studios_id"
																				name="studios_id"
																				value={this.state.data.id}
																			/>
																		</span>
																		<button
																			id="sdk_change_save"
																			className="editprimary-btn"
																			onClick={this.toggle2.bind(this)}
																			style={{ display: "none" }}
																		>
																			Save
																		</button>
																		{this.state.apiKey ? (
																			this.state.apiKeyStatus == 1 ? (
																				<button
																					class="editprimary-btn"
																					onClick={() => this.disabletoken()}
																				>
																					<span>
																						<svg
																							xmlns="http://www.w3.org/2000/svg"
																							width="12"
																							height="12"
																							viewBox="0 0 12 12"
																							fill="none"
																						>
																							<g clip-path="url(#clip0_501_8376)">
																								<path
																									d="M8.5 1.5C8.63132 1.36868 8.78722 1.26451 8.9588 1.19344C9.13038 1.12236 9.31428 1.08578 9.5 1.08578C9.68572 1.08578 9.86962 1.12236 10.0412 1.19344C10.2128 1.26451 10.3687 1.36868 10.5 1.5C10.6313 1.63132 10.7355 1.78722 10.8066 1.9588C10.8776 2.13038 10.9142 2.31428 10.9142 2.5C10.9142 2.68572 10.8776 2.86961 10.8066 3.04119C10.7355 3.21277 10.6313 3.36868 10.5 3.5L3.75 10.25L1 11L1.75 8.25L8.5 1.5Z"
																									stroke="#006EFA"
																									stroke-width="1.33"
																									stroke-linecap="round"
																									stroke-linejoin="round"
																								></path>
																							</g>
																							<defs>
																								<clipPath id="clip0_501_8376">
																									<rect
																										width="12"
																										height="12"
																										fill="white"
																									></rect>
																								</clipPath>
																							</defs>
																						</svg>
																					</span>
																					Disable Token
																				</button>
																			) : (
																				<span class="disabled">Disabled</span>
																			)
																		) : (
																			<button
																				className="editprimary-btn"
																				onClick={() => this.generatetoken()}
																			>
																				Generate Token
																			</button>
																		)}
																	</div>
																</div>
															</div>
														</div>
														<div class="app-box">
															<div class="d-flex">
																<h3>Android Mobile/Android TV</h3>
																<button
																	class="editprimary-btn"
																	onClick={this.android_edit.bind(this)}
																>
																	<span>
																		<svg
																			xmlns="http://www.w3.org/2000/svg"
																			width="12"
																			height="12"
																			viewBox="0 0 12 12"
																			fill="none"
																		>
																			<g clip-path="url(#clip0_501_8376)">
																				<path
																					d="M8.5 1.5C8.63132 1.36868 8.78722 1.26451 8.9588 1.19344C9.13038 1.12236 9.31428 1.08578 9.5 1.08578C9.68572 1.08578 9.86962 1.12236 10.0412 1.19344C10.2128 1.26451 10.3687 1.36868 10.5 1.5C10.6313 1.63132 10.7355 1.78722 10.8066 1.9588C10.8776 2.13038 10.9142 2.31428 10.9142 2.5C10.9142 2.68572 10.8776 2.86961 10.8066 3.04119C10.7355 3.21277 10.6313 3.36868 10.5 3.5L3.75 10.25L1 11L1.75 8.25L8.5 1.5Z"
																					stroke="#006EFA"
																					stroke-width="1.33"
																					stroke-linecap="round"
																					stroke-linejoin="round"
																				></path>
																			</g>
																			<defs>
																				<clipPath id="clip0_501_8376">
																					<rect
																						width="12"
																						height="12"
																						fill="white"
																					></rect>
																				</clipPath>
																			</defs>
																		</svg>
																	</span>
																	Edit
																</button>
															</div>
															{this.state.android_view_state == 1
																? this.getViewAndroidInfo()
																: this.getEditAndroidInfo()}
														</div>
													</div>

													<div class="col-md-6">
														<div class="app-box">
															<div class="d-flex">
																<h3>Roku TV</h3>
																<button
																	class="editprimary-btn"
																	onClick={this.roku_edit.bind(this)}
																>
																	<span>
																		<svg
																			xmlns="http://www.w3.org/2000/svg"
																			width="12"
																			height="12"
																			viewBox="0 0 12 12"
																			fill="none"
																		>
																			<g clip-path="url(#clip0_501_8376)">
																				<path
																					d="M8.5 1.5C8.63132 1.36868 8.78722 1.26451 8.9588 1.19344C9.13038 1.12236 9.31428 1.08578 9.5 1.08578C9.68572 1.08578 9.86962 1.12236 10.0412 1.19344C10.2128 1.26451 10.3687 1.36868 10.5 1.5C10.6313 1.63132 10.7355 1.78722 10.8066 1.9588C10.8776 2.13038 10.9142 2.31428 10.9142 2.5C10.9142 2.68572 10.8776 2.86961 10.8066 3.04119C10.7355 3.21277 10.6313 3.36868 10.5 3.5L3.75 10.25L1 11L1.75 8.25L8.5 1.5Z"
																					stroke="#006EFA"
																					stroke-width="1.33"
																					stroke-linecap="round"
																					stroke-linejoin="round"
																				></path>
																			</g>
																			<defs>
																				<clipPath id="clip0_501_8376">
																					<rect
																						width="12"
																						height="12"
																						fill="white"
																					></rect>
																				</clipPath>
																			</defs>
																		</svg>
																	</span>
																	Edit
																</button>
															</div>
															{this.state.roku_view_state == 1
																? this.getViewRokuInfo()
																: this.getEditRokuInfo()}
														</div>
														<div class="app-box">
															<div class="d-flex">
																<h3>iOS Mobile/Apple TV</h3>
																<button
																	class="editprimary-btn"
																	onClick={this.ios_edit.bind(this)}
																>
																	<span>
																		<svg
																			xmlns="http://www.w3.org/2000/svg"
																			width="12"
																			height="12"
																			viewBox="0 0 12 12"
																			fill="none"
																		>
																			<g clip-path="url(#clip0_501_8376)">
																				<path
																					d="M8.5 1.5C8.63132 1.36868 8.78722 1.26451 8.9588 1.19344C9.13038 1.12236 9.31428 1.08578 9.5 1.08578C9.68572 1.08578 9.86962 1.12236 10.0412 1.19344C10.2128 1.26451 10.3687 1.36868 10.5 1.5C10.6313 1.63132 10.7355 1.78722 10.8066 1.9588C10.8776 2.13038 10.9142 2.31428 10.9142 2.5C10.9142 2.68572 10.8776 2.86961 10.8066 3.04119C10.7355 3.21277 10.6313 3.36868 10.5 3.5L3.75 10.25L1 11L1.75 8.25L8.5 1.5Z"
																					stroke="#006EFA"
																					stroke-width="1.33"
																					stroke-linecap="round"
																					stroke-linejoin="round"
																				></path>
																			</g>
																			<defs>
																				<clipPath id="clip0_501_8376">
																					<rect
																						width="12"
																						height="12"
																						fill="white"
																					></rect>
																				</clipPath>
																			</defs>
																		</svg>
																	</span>
																	Edit
																</button>
															</div>
															{this.state.ios_view_state == 1
																? this.getViewiosInfo()
																: this.getEditiosInfo()}
														</div>
													</div>
												</div>
											</div>
											<div role="tabpanel" class="tab-pane" id="login">
												{this.state.isLoadingApiCalling ? (
													<div className="loader-new"></div>
												) : this.state.login_details.length > 0 ? (
													<div className="table-wrap">
														<table class="crm-table" style={{ width: "100%" }}>
															<thead>
																<tr>
																	<th width="900">Email</th>
																	<th width="167">Date &amp; Time</th>
																</tr>
															</thead>
															<tbody>
																{this.state.login_details.map((details, key) => (
																	<tr>
																		<td className="email">
																			{maskEmail(details.email || "", 2, "email")}
																		</td>
																		<td>
																			{" "}
																			{details.login_at !=
																				"0000-00-00 00:00:00" &&
																				details.login_at != " "
																				? details.login_at
																				: ""}
																		</td>
																	</tr>
																))}
															</tbody>
														</table>
													</div>
												) : (
													<div class="row">
														<div className="not-data-found">
															<svg
																width="56"
																height="56"
																viewBox="0 0 56 56"
																fill="none"
																xmlns="http://www.w3.org/2000/svg"
															>
																<g clip-path="url(#clip0_504_30600)">
																	<path
																		d="M48.5215 39.9595C48.959 40.7456 49.8374 41.1301 50.738 41.125C52.2693 41.1182 53.4963 42.4221 53.3647 43.979C53.2485 45.3582 52.0044 46.375 50.6201 46.375H42V47.25H6.12498C4.62791 47.25 3.42479 45.9973 3.5034 44.4849C3.5786 43.0647 4.85179 42 6.27366 42H6.99998C8.06297 42 8.90379 41.0532 8.72606 39.9561C8.58592 39.0964 7.77757 38.5 6.90599 38.5H2.62498C1.12791 38.5 -0.0752122 37.2473 0.00340108 35.7349C0.0785966 34.3147 1.35179 33.25 2.77366 33.25H8.31248C9.52073 33.25 10.5 32.2708 10.5 31.0625C10.5 29.8542 9.52073 28.875 8.31248 28.875C7.10423 28.875 6.12498 27.8958 6.12498 26.6875C6.12498 25.4792 7.10423 24.5 8.31248 24.5H15.75V18.375H9.18748C7.44261 18.375 6.03612 16.9138 6.13011 15.1484C6.21556 13.4924 7.70237 12.25 9.36009 12.25H15.75V8.75H49.4375C51.1824 8.75 52.5888 10.2112 52.4949 11.9766C52.4094 13.6326 50.9226 14.875 49.2649 14.875H46.8125C45.0676 14.875 43.6611 16.3362 43.7551 18.1016C43.8406 19.7576 45.3274 21 46.9851 21H49C50.5552 21 51.7942 22.3535 51.6062 23.9446C51.449 25.2656 50.2527 26.1953 48.9248 26.2517C47.8772 26.2944 47.0688 27.26 47.2842 28.3555C47.4499 29.186 48.2326 29.75 49.0786 29.75H52.9375C54.6824 29.75 56.0888 31.2112 55.9949 32.9766C55.9094 34.6326 54.4226 35.875 52.7649 35.875H50.75C48.8325 35.875 47.3952 37.9309 48.5215 39.9595ZM2.18748 28.875C3.39573 28.875 4.37498 27.8958 4.37498 26.6875C4.37498 25.4792 3.39573 24.5 2.18748 24.5C0.979231 24.5 -1.6893e-05 25.4792 -1.6893e-05 26.6875C-1.6893e-05 27.8958 0.979231 28.875 2.18748 28.875ZM2.18748 28.875C3.39573 28.875 4.37498 27.8958 4.37498 26.6875C4.37498 25.4792 3.39573 24.5 2.18748 24.5C0.979231 24.5 -1.6893e-05 25.4792 -1.6893e-05 26.6875C-1.6893e-05 27.8958 0.979231 28.875 2.18748 28.875Z"
																		fill="#EFF6FE"
																	></path>
																	<path
																		d="M12.8 49V7H34.7516L45.2 17.4484V49H12.8Z"
																		fill="white"
																	></path>
																	<path
																		d="M33.6747 7.60002C34.2052 7.60002 34.7139 7.81074 35.0889 8.18581L44.0142 17.111C44.3892 17.4861 44.6 17.9948 44.6 18.5253V46.4C44.6 47.5046 43.7045 48.4 42.6 48.4H15.4C14.2954 48.4 13.4 47.5046 13.4 46.4V9.60002C13.4 8.49545 14.2954 7.60002 15.4 7.60002H33.6747ZM35.5857 6.98581C35.2107 6.61074 34.702 6.40002 34.1715 6.40002H14.2C13.0954 6.40002 12.2 7.29545 12.2 8.40002V47.6C12.2 48.7046 13.0954 49.6 14.2 49.6H43.8C44.9045 49.6 45.8 48.7046 45.8 47.6V18.0285C45.8 17.498 45.5892 16.9893 45.2142 16.6142L35.5857 6.98581Z"
																		fill="#E2EAF3"
																	></path>
																	<path
																		d="M34.4 17.8V7H34.7516L45.2 17.4484V17.8H34.4Z"
																		fill="white"
																	></path>
																	<path
																		d="M35 8.09682L44.1032 17.2H37C35.8955 17.2 35 16.3046 35 15.2V8.09682ZM35 6.40002H33.8V16.4C33.8 17.5046 34.6955 18.4 35.8 18.4H45.8V17.2L35 6.40002Z"
																		fill="#E2EAF3"
																	></path>
																	<path
																		d="M32.6 29.4028L29 32.8L34.4648 38.8H38.6V35.2L32.6 29.4028Z"
																		fill="#7AADF0"
																	></path>
																	<path
																		d="M36.2 22C35.5635 22 34.9531 22.2529 34.503 22.7029C34.0529 23.153 33.8 23.7635 33.8 24.4C33.8 25.0365 34.0529 25.647 34.503 26.0971C34.9531 26.5471 35.5635 26.8 36.2 26.8C36.8365 26.8 37.447 26.5471 37.8971 26.0971C38.3472 25.647 38.6 25.0365 38.6 24.4C38.6 23.7635 38.3472 23.153 37.8971 22.7029C37.447 22.2529 36.8365 22 36.2 22ZM36.2 38.8H19.4V34L25.4 28L36.2 38.8Z"
																		fill="#B5DEFF"
																	></path>
																</g>
																<defs>
																	<clipPath id="clip0_504_30600">
																		<rect
																			width="56"
																			height="56"
																			fill="white"
																		></rect>
																	</clipPath>
																</defs>
															</svg>
															<div class="mt-3">No Data found</div>
														</div>
													</div>
												)}
											</div>
											<div role="tabpanel" class="tab-pane ana-upload" id="upload">
												{this.getuploaddetails()}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
const styleObj = {
	snote: {
		color: "#657080",
		fontSize: "11px",
		fontWeight: "400",
		lineHeight: "18px",
	},
	intra_col_15: {
		width: "15%",
		wordWrap: "break-word",
		wordBreak: "break-all",
	},
	intra_col_13: { width: "13%" },
	intra_col_10: { width: "10%" },
	intra_col_20: {
		width: "20%",
		wordWrap: "break-word",
		wordBreak: "break-all",
	},
	intra_col_2: {
		width: "2%",
	},
	upload_ul_li: {
		// padding: "5px 0",
		// fontSize: "10px",
	},
	table_heading: {
		fontSize: "10px",
		padding: "8.4px 3px",
	},
	table_td: {
		fontSize: "9px",
		padding: "0px 5px",
		height: "30px",
		lineHeight: "18px",
	},
};
export default NewLayoutFive;



// WEBPACK FOOTER //
// ./src/components/crm/customer/NewlayoutFive.js